import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  VOID7hggqo3abtya as VOID,
  createThis2j2avj17cvnv2 as createThis,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  equals2au1ep9vhcato as equals,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  protoOf180f3jzyo7rfj as protoOf,
  Comparable198qfk8pnblz0 as Comparable,
  KtList3hktaavzmj137 as KtList,
  toSet2orjxp16sotqu as toSet,
  Collection1k04j3hzsbod0 as Collection,
  isInterface3d6p8outrmvmk as isInterface,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  isNaNymqb93xtq8w8 as isNaN_0,
  Unit_instanceat14thlj150z as Unit_instance,
  Enum3alwj03lh1n41 as Enum,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  contentEquals379bkuxwxaiqz as contentEquals,
  contentHashCode2dpr73siofp13 as contentHashCode,
  StringBuildermazzzhj6kkai as StringBuilder,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  numberToDouble210hrknaofnhf as numberToDouble,
  coerceIn10f36k81le1mm as coerceIn,
  minOfmf6w75l7u1a7 as minOf,
  maxOf1m19db8qhkqy5 as maxOf,
} from './kotlin-kotlin-stdlib.mjs';
import {
  _Ratio___init__impl__9mwvn2xyj9fjgana63 as _Ratio___init__impl__9mwvn2,
  umod1d8wj61c81r0q as umod,
  isAlmostEquals2e7wogp48cvmj as isAlmostEquals,
  Ratio__toDouble_impl_o7epze2ppsc3gplivz8 as Ratio__toDouble_impl_o7epze,
  toRatio1hooqit5gulhr as toRatio,
  Ratio__times_impl_ucdh7y2x1w5kf040xma as Ratio__times_impl_ucdh7y,
  Ratio__compareTo_impl_z2iencsp0le8uhwq33 as Ratio__compareTo_impl_z2ienc,
  roundDecimalPlaces1x32iuyd1l8m5 as roundDecimalPlaces,
  get_niceStr3crhxydmlnaoj as get_niceStr,
  isAlmostEquals$default2ib7nwup21mfy as isAlmostEquals$default,
  IsAlmostEquals2vs54x7i426j2 as IsAlmostEquals,
  interpolate2g7wzskc23f1q as interpolate,
  interpolate35pbs3ac913y4 as interpolate_0,
  get_niceStr1tlwtz2l2j4my as get_niceStr_0,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
//region block: imports
var imul = Math.imul;
var hypot = Math.hypot;
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    Companion_instance = this;
    this.n24_1 = Anchor2D.y24(0.0, 0.0);
    this.o24_1 = Anchor2D.y24(0.5, 0.0);
    this.p24_1 = Anchor2D.y24(1.0, 0.0);
    this.q24_1 = Anchor2D.y24(0.0, 0.5);
    this.r24_1 = Anchor2D.y24(0.5, 0.5);
    this.s24_1 = Anchor2D.y24(1.0, 0.5);
    this.t24_1 = Anchor2D.y24(0.0, 1.0);
    this.u24_1 = Anchor2D.y24(0.5, 1.0);
    this.v24_1 = Anchor2D.y24(1.0, 1.0);
  }
  z24() {
    return this.r24_1;
  }
}
class Anchor2D {
  static a25(sx, sy) {
    Companion_getInstance();
    var $this = createThis(this);
    $this.w24_1 = sx;
    $this.x24_1 = sy;
    return $this;
  }
  static y24(sx, sy) {
    Companion_getInstance();
    return this.a25(sx, sy);
  }
  toString() {
    return 'Anchor2D(sx=' + this.w24_1 + ', sy=' + this.x24_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.w24_1);
    result = imul(result, 31) + getNumberHashCode(this.x24_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Anchor2D))
      return false;
    var tmp0_other_with_cast = other instanceof Anchor2D ? other : THROW_CCE();
    if (!equals(this.w24_1, tmp0_other_with_cast.w24_1))
      return false;
    if (!equals(this.x24_1, tmp0_other_with_cast.x24_1))
      return false;
    return true;
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_0 = this;
    var tmp = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio = toRatio(1.0E-5);
    var tmp$ret$0 = Ratio__times_impl_ucdh7y(ratio, 6.283185307179586);
    tmp.c25_1 = _Angle___init__impl__g23q1m(tmp$ret$0);
    var tmp_0 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio_0 = toRatio(0.0);
    var tmp$ret$2 = Ratio__times_impl_ucdh7y(ratio_0, 6.283185307179586);
    tmp_0.d25_1 = _Angle___init__impl__g23q1m(tmp$ret$2);
    var tmp_1 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio_1 = toRatio(0.25);
    var tmp$ret$4 = Ratio__times_impl_ucdh7y(ratio_1, 6.283185307179586);
    tmp_1.e25_1 = _Angle___init__impl__g23q1m(tmp$ret$4);
    var tmp_2 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio_2 = toRatio(0.5);
    var tmp$ret$6 = Ratio__times_impl_ucdh7y(ratio_2, 6.283185307179586);
    tmp_2.f25_1 = _Angle___init__impl__g23q1m(tmp$ret$6);
    var tmp_3 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio_3 = toRatio(0.75);
    var tmp$ret$8 = Ratio__times_impl_ucdh7y(ratio_3, 6.283185307179586);
    tmp_3.g25_1 = _Angle___init__impl__g23q1m(tmp$ret$8);
    var tmp_4 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio_4 = toRatio(1.0);
    var tmp$ret$10 = Ratio__times_impl_ucdh7y(ratio_4, 6.283185307179586);
    tmp_4.h25_1 = _Angle___init__impl__g23q1m(tmp$ret$10);
  }
}
class Angle {
  constructor(radians) {
    Companion_getInstance_0();
    this.b25_1 = radians;
  }
  i25(other, epsilon) {
    return Angle__isAlmostEquals_impl_201sgt(this.b25_1, other, epsilon);
  }
  ex(other, epsilon) {
    return Angle__isAlmostEquals_impl_201sgt_0(this, other, epsilon);
  }
  j25(other) {
    return Angle__compareTo_impl_a0hfds(this.b25_1, other);
  }
  d(other) {
    return Angle__compareTo_impl_a0hfds_0(this, other);
  }
  toString() {
    return Angle__toString_impl_786qky(this.b25_1);
  }
  hashCode() {
    return Angle__hashCode_impl_szcndt(this.b25_1);
  }
  equals(other) {
    return Angle__equals_impl_zcf5mt(this.b25_1, other);
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_1 = this;
    this.h26_1 = _BoundsBuilder___init__impl__g6dprh(Companion_getInstance_12().l26());
  }
  m26() {
    return this.h26_1;
  }
  n26(p1, p2, p3, p4) {
    return _BoundsBuilder___init__impl__g6dprh(Companion_getInstance_12().q26(Companion_getInstance_17().o26(p1, p2, p3, p4), Companion_getInstance_17().p26(p1, p2, p3, p4)));
  }
}
class BoundsBuilder {
  constructor(bounds) {
    Companion_getInstance_1();
    this.z26_1 = bounds;
  }
  toString() {
    return BoundsBuilder__toString_impl_fmvxh7(this.z26_1);
  }
  hashCode() {
    return BoundsBuilder__hashCode_impl_649zbo(this.z26_1);
  }
  equals(other) {
    return BoundsBuilder__equals_impl_jngfjs(this.z26_1, other);
  }
}
class Companion_2 {}
class Circle {
  constructor(center, radius) {
    this.a27_1 = center;
    this.b27_1 = radius;
  }
  c27() {
    return this.b27_1 * this.b27_1;
  }
  d27(p) {
    return Companion_getInstance_17().e27(p, this.a27_1);
  }
  f27(p) {
    return this.d27(p) - this.c27();
  }
  g27(p) {
    return this.d27(p) + this.c27();
  }
  toString() {
    return 'Circle(center=' + this.a27_1.toString() + ', radius=' + this.b27_1 + ')';
  }
  hashCode() {
    var result = this.a27_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.b27_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Circle))
      return false;
    var tmp0_other_with_cast = other instanceof Circle ? other : THROW_CCE();
    if (!this.a27_1.equals(tmp0_other_with_cast.a27_1))
      return false;
    if (!equals(this.b27_1, tmp0_other_with_cast.b27_1))
      return false;
    return true;
  }
}
class IPointList$Sublist$listIterator$1 {
  constructor($index, this$0) {
    this.i27_1 = $index;
    this.j27_1 = this$0;
    this.h27_1 = $index;
  }
  b1() {
    return this.h27_1 >= this.j27_1.n27_1;
  }
  c1() {
    var _unary__edvuaz = this.h27_1;
    this.h27_1 = _unary__edvuaz + 1 | 0;
    return this.j27_1.d1(_unary__edvuaz);
  }
}
class Sublist {
  constructor(list, fromIndex, toIndex) {
    this.k27_1 = list;
    this.l27_1 = fromIndex;
    this.m27_1 = toIndex;
    this.n27_1 = this.m27_1 - this.l27_1 | 0;
  }
  e1() {
    return this.n27_1;
  }
  d1(index) {
    return this.k27_1.d1(index + this.l27_1 | 0);
  }
  g1() {
    return this.n27_1 === 0;
  }
  a1() {
    return this.b3();
  }
  b3() {
    return this.i1(0);
  }
  i1(index) {
    return new IPointList$Sublist$listIterator$1(index, this);
  }
  c3(fromIndex, toIndex) {
    return new Sublist(this.k27_1, this.l27_1 + fromIndex | 0, this.l27_1 + toIndex | 0);
  }
  o27(element) {
    return Companion_instance_3.p27(this.k27_1, element, this.l27_1, this.m27_1, -this.l27_1 | 0);
  }
  l1(element) {
    if (!(element instanceof Vector2D))
      return -1;
    return this.o27(element instanceof Vector2D ? element : THROW_CCE());
  }
  q27(elements) {
    return Companion_instance_3.r27(this, elements);
  }
  a3(elements) {
    return this.q27(elements);
  }
  s27(element) {
    return this.o27(element) >= 0;
  }
  z2(element) {
    if (!(element instanceof Vector2D))
      return false;
    return this.s27(element instanceof Vector2D ? element : THROW_CCE());
  }
}
class Companion_3 {
  r27(_this__u8e3s4, elements) {
    var s = toSet(elements);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(_this__u8e3s4, Collection)) {
        tmp = _this__u8e3s4.g1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = _this__u8e3s4.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.math.geom.Companion.containsAllSet.<anonymous>' call
        if (!s.z2(element)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  p27(list, element, fromIndex, toIndex, offset) {
    var inductionVariable = fromIndex;
    if (inductionVariable < toIndex)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (list.t27(n) === element.m25_1 && list.u27(n) === element.n25_1)
          return n + offset | 0;
      }
       while (inductionVariable < toIndex);
    return -1;
  }
  v27(list, element, fromIndex, toIndex, offset, $super) {
    fromIndex = fromIndex === VOID ? 0 : fromIndex;
    toIndex = toIndex === VOID ? list.e1() : toIndex;
    offset = offset === VOID ? 0 : offset;
    return $super === VOID ? this.p27(list, element, fromIndex, toIndex, offset) : $super.p27.call(this, list, element, fromIndex, toIndex, offset);
  }
}
class IDoubleVectorList {}
function isNotEmpty() {
  return !(this.e1() === 0);
}
function isAlmostEquals_0(other, epsilon) {
  if (!(this.e1() === other.e1()))
    return false;
  if (!(this.a28() === other.a28()))
    return false;
  var inductionVariable = 0;
  var last = this.a28();
  if (inductionVariable < last)
    do {
      var dim = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 0;
      var last_0 = this.e1();
      if (inductionVariable_0 < last_0)
        do {
          var n = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (!isAlmostEquals(this.y27(n, dim), other.y27(n, dim), epsilon))
            return false;
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
  return true;
}
class IPointList {}
function get(index) {
  return Vector2D.w27(this.t27(index), this.u27(index));
}
function containsAll(elements) {
  return Companion_instance_3.r27(this, elements);
}
function indexOf(element) {
  return Companion_instance_3.v27(this, element);
}
function iterator() {
  return this.b3();
}
function listIterator() {
  return this.i1(0);
}
function listIterator_0(index) {
  return (new Sublist(this, 0, this.e1())).i1(index);
}
function subList(fromIndex, toIndex) {
  return new Sublist(this, fromIndex, toIndex);
}
class Companion_4 {
  constructor() {
    Companion_instance_4 = this;
    this.b28_1 = Line2D.f28(Companion_getInstance_17().o25_1, Companion_getInstance_17().o25_1);
    this.c28_1 = Line2D.f28(Companion_getInstance_17().p25_1, Companion_getInstance_17().p25_1);
  }
}
class Line2D {
  static f28(a, b) {
    Companion_getInstance_4();
    var $this = createThis(this);
    $this.d28_1 = a;
    $this.e28_1 = b;
    return $this;
  }
  static g28() {
    Companion_getInstance_4();
    return this.f28(Vector2D.h28(), Vector2D.h28());
  }
  static i28(x0, y0, x1, y1) {
    Companion_getInstance_4();
    return this.f28(Vector2D.j28(x0, y0), Vector2D.j28(x1, y1));
  }
  k28() {
    return this.d28_1.m25_1;
  }
  l28() {
    return this.d28_1.n25_1;
  }
  m28() {
    return this.e28_1.m25_1;
  }
  n28() {
    return this.e28_1.n25_1;
  }
  toString() {
    return 'Line(' + this.d28_1.toString() + ', ' + this.e28_1.toString() + ')';
  }
  hashCode() {
    var result = this.d28_1.hashCode();
    result = imul(result, 31) + this.e28_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Line2D))
      return false;
    var tmp0_other_with_cast = other instanceof Line2D ? other : THROW_CCE();
    if (!this.d28_1.equals(tmp0_other_with_cast.d28_1))
      return false;
    if (!this.e28_1.equals(tmp0_other_with_cast.e28_1))
      return false;
    return true;
  }
}
class Companion_5 {
  constructor() {
    Companion_instance_5 = this;
    this.o28_1 = Margin.t28(0.0, 0.0, 0.0, 0.0);
  }
}
class Margin {
  static t28(top, right, bottom, left) {
    Companion_getInstance_5();
    var $this = createThis(this);
    $this.p28_1 = top;
    $this.q28_1 = right;
    $this.r28_1 = bottom;
    $this.s28_1 = left;
    return $this;
  }
  static u28(margin) {
    Companion_getInstance_5();
    return this.t28(margin, margin, margin, margin);
  }
  v28(other, epsilon) {
    return isAlmostEquals(this.s28_1, other.s28_1, epsilon) && isAlmostEquals(this.q28_1, other.q28_1, epsilon) && isAlmostEquals(this.p28_1, other.p28_1, epsilon) && isAlmostEquals(this.r28_1, other.r28_1, epsilon);
  }
  ex(other, epsilon) {
    return this.v28(other instanceof Margin ? other : THROW_CCE(), epsilon);
  }
  w28() {
    return this.s28_1 + this.q28_1;
  }
  x28() {
    return this.p28_1 + this.r28_1;
  }
  toString() {
    return 'Margin(top=' + get_niceStr(this.p28_1) + ', right=' + get_niceStr(this.q28_1) + ', bottom=' + get_niceStr(this.r28_1) + ', left=' + get_niceStr(this.s28_1) + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.p28_1);
    result = imul(result, 31) + getNumberHashCode(this.q28_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.r28_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.s28_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Margin))
      return false;
    var tmp0_other_with_cast = other instanceof Margin ? other : THROW_CCE();
    if (!equals(this.p28_1, tmp0_other_with_cast.p28_1))
      return false;
    if (!equals(this.q28_1, tmp0_other_with_cast.q28_1))
      return false;
    if (!equals(this.r28_1, tmp0_other_with_cast.r28_1))
      return false;
    if (!equals(this.s28_1, tmp0_other_with_cast.s28_1))
      return false;
    return true;
  }
}
class Companion_6 {
  constructor() {
    Companion_instance_6 = this;
    this.y28_1 = MarginInt.d29(0, 0, 0, 0);
  }
}
class MarginInt {
  static d29(top, right, bottom, left) {
    Companion_getInstance_6();
    var $this = createThis(this);
    $this.z28_1 = top;
    $this.a29_1 = right;
    $this.b29_1 = bottom;
    $this.c29_1 = left;
    return $this;
  }
  static e29(margin) {
    Companion_getInstance_6();
    return this.d29(margin, margin, margin, margin);
  }
  f29() {
    return !(this.z28_1 === 0) || !(this.c29_1 === 0) || !(this.a29_1 === 0) || !(this.b29_1 === 0);
  }
  w28() {
    return this.c29_1 + this.a29_1 | 0;
  }
  x28() {
    return this.z28_1 + this.b29_1 | 0;
  }
  toString() {
    return 'MarginInt(top=' + this.z28_1 + ', right=' + this.a29_1 + ', bottom=' + this.b29_1 + ', left=' + this.c29_1 + ')';
  }
  hashCode() {
    var result = this.z28_1;
    result = imul(result, 31) + this.a29_1 | 0;
    result = imul(result, 31) + this.b29_1 | 0;
    result = imul(result, 31) + this.c29_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MarginInt))
      return false;
    var tmp0_other_with_cast = other instanceof MarginInt ? other : THROW_CCE();
    if (!(this.z28_1 === tmp0_other_with_cast.z28_1))
      return false;
    if (!(this.a29_1 === tmp0_other_with_cast.a29_1))
      return false;
    if (!(this.b29_1 === tmp0_other_with_cast.b29_1))
      return false;
    if (!(this.c29_1 === tmp0_other_with_cast.c29_1))
      return false;
    return true;
  }
}
class Companion_7 {
  constructor() {
    Companion_instance_7 = this;
    this.g29_1 = new Matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0);
    this.h29_1 = new Matrix(NaN, NaN, NaN, NaN, NaN, NaN);
    this.i29_1 = this.h29_1;
  }
  j29() {
    return this.g29_1;
  }
  k29(a, b, epsilon) {
    return isAlmostEquals(a.p29_1, b.p29_1, epsilon) && isAlmostEquals(a.q29_1, b.q29_1, epsilon) && isAlmostEquals(a.l29_1, b.l29_1, epsilon) && isAlmostEquals(a.m29_1, b.m29_1, epsilon) && isAlmostEquals(a.n29_1, b.n29_1, epsilon) && isAlmostEquals(a.o29_1, b.o29_1, epsilon);
  }
  r29(l, r) {
    if (l.b26())
      return r;
    if (r.b26())
      return l;
    return new Matrix(l.l29_1 * r.l29_1 + l.m29_1 * r.n29_1, l.l29_1 * r.m29_1 + l.m29_1 * r.o29_1, l.n29_1 * r.l29_1 + l.o29_1 * r.n29_1, l.n29_1 * r.m29_1 + l.o29_1 * r.o29_1, l.p29_1 * r.l29_1 + l.q29_1 * r.n29_1 + r.p29_1, l.p29_1 * r.m29_1 + l.q29_1 * r.o29_1 + r.q29_1);
  }
  s29(x, y, rotation, scaleX, scaleY, skewX, skewY, pivotX, pivotY) {
    // Inline function 'korlibs.math.geom.cos' call
    var angle = Angle__plus_impl_26v37k(rotation, skewY);
    var up = Companion_getInstance_17().s25_1;
    var a = Angle__cosine_impl_bgvzun(angle, up) * scaleX + 0.0;
    // Inline function 'korlibs.math.geom.sin' call
    var angle_0 = Angle__plus_impl_26v37k(rotation, skewY);
    var up_0 = Companion_getInstance_17().s25_1;
    var b = Angle__sine_impl_3l11xv(angle_0, up_0) * scaleX + 0.0;
    // Inline function 'korlibs.math.geom.sin' call
    var angle_1 = Angle__minus_impl_xeau7k(rotation, skewX);
    var up_1 = Companion_getInstance_17().s25_1;
    var c = -Angle__sine_impl_3l11xv(angle_1, up_1) * scaleY + 0.0;
    // Inline function 'korlibs.math.geom.cos' call
    var angle_2 = Angle__minus_impl_xeau7k(rotation, skewX);
    var up_2 = Companion_getInstance_17().s25_1;
    var d = Angle__cosine_impl_bgvzun(angle_2, up_2) * scaleY + 0.0;
    var tx;
    var ty;
    if (pivotX === 0.0 && pivotY === 0.0) {
      tx = x;
      ty = y;
    } else {
      tx = x - (pivotX * a + pivotY * c);
      ty = y - (pivotX * b + pivotY * d);
    }
    return new Matrix(a, b, c, d, tx, ty);
  }
  t29(a, b, c, d, tx, ty, p) {
    return Vector2D.w27(a * p.m25_1 + c * p.n25_1 + tx, d * p.n25_1 + b * p.m25_1 + ty);
  }
}
class Matrix {
  constructor(a, b, c, d, tx, ty) {
    Companion_getInstance_7();
    tx = tx === VOID ? 0.0 : tx;
    ty = ty === VOID ? 0.0 : ty;
    this.l29_1 = a;
    this.m29_1 = b;
    this.n29_1 = c;
    this.o29_1 = d;
    this.p29_1 = tx;
    this.q29_1 = ty;
  }
  u29(other) {
    return Companion_getInstance_7().r29(this, other);
  }
  b26() {
    return isNaN_0(this.l29_1);
  }
  c26() {
    return !this.b26();
  }
  v29() {
    return this.l29_1 === 1.0 && this.m29_1 === 0.0 && this.n29_1 === 0.0 && this.o29_1 === 1.0 && this.p29_1 === 0.0 && this.q29_1 === 0.0;
  }
  w29() {
    var hasRotation = !(this.m29_1 === 0.0) || !(this.n29_1 === 0.0);
    var hasScale = !(this.l29_1 === 1.0) || !(this.o29_1 === 1.0);
    var hasTranslation = !(this.p29_1 === 0.0) || !(this.q29_1 === 0.0);
    return hasRotation ? MatrixType_COMPLEX_getInstance() : hasScale && hasTranslation ? MatrixType_SCALE_TRANSLATE_getInstance() : hasScale ? MatrixType_SCALE_getInstance() : hasTranslation ? MatrixType_TRANSLATE_getInstance() : MatrixType_IDENTITY_getInstance();
  }
  x29(p) {
    return this.y29(p.m25_1, p.n25_1);
  }
  z29(x, y) {
    return this.y29(x, y);
  }
  a2a(x, y) {
    return this.b2a(x, y);
  }
  y29(x, y) {
    return this.l29_1 * x + this.n29_1 * y + this.p29_1;
  }
  b2a(x, y) {
    return this.o29_1 * y + this.m29_1 * x + this.q29_1;
  }
  c2a(x, y) {
    return this.y29(x, y);
  }
  d2a(x, y) {
    return this.b2a(x, y);
  }
  e2a(angle) {
    // Inline function 'korlibs.math.geom.cos' call
    var up = Companion_getInstance_17().s25_1;
    var cos = Angle__cosine_impl_bgvzun(angle, up);
    // Inline function 'korlibs.math.geom.sin' call
    var up_0 = Companion_getInstance_17().s25_1;
    var sin = Angle__sine_impl_3l11xv(angle, up_0);
    var a1 = this.l29_1 * cos - this.m29_1 * sin;
    var b = this.l29_1 * sin + this.m29_1 * cos;
    var a = a1;
    var c1 = this.n29_1 * cos - this.o29_1 * sin;
    var d = this.n29_1 * sin + this.o29_1 * cos;
    var c = c1;
    var tx1 = this.p29_1 * cos - this.q29_1 * sin;
    var ty = this.p29_1 * sin + this.q29_1 * cos;
    var tx = tx1;
    return new Matrix(a, b, c, d, tx, ty);
  }
  f2a(scaleX, scaleY) {
    return this.g2a(scaleX, scaleY);
  }
  g2a(scaleX, scaleY) {
    return new Matrix(this.l29_1 * scaleX, this.m29_1 * scaleX, this.n29_1 * scaleY, this.o29_1 * scaleY, this.p29_1 * scaleX, this.q29_1 * scaleY);
  }
  h2a(scaleX, scaleY, $super) {
    scaleY = scaleY === VOID ? scaleX : scaleY;
    return $super === VOID ? this.g2a(scaleX, scaleY) : $super.g2a.call(this, scaleX, scaleY);
  }
  i2a(scaleX, scaleY) {
    return new Matrix(this.l29_1 * scaleX, this.m29_1 * scaleX, this.n29_1 * scaleY, this.o29_1 * scaleY, this.p29_1, this.q29_1);
  }
  j2a(scaleX, scaleY, $super) {
    scaleY = scaleY === VOID ? scaleX : scaleY;
    return $super === VOID ? this.i2a(scaleX, scaleY) : $super.i2a.call(this, scaleX, scaleY);
  }
  k2a(delta) {
    return new Matrix(this.l29_1, this.m29_1, this.n29_1, this.o29_1, this.p29_1 + delta.m25_1, this.q29_1 + delta.n25_1);
  }
  l2a(x, y) {
    return this.k2a(Vector2D.j28(x, y));
  }
  m2a(x, y) {
    return this.k2a(Vector2D.w27(x, y));
  }
  n2a(delta) {
    return new Matrix(this.l29_1, this.m29_1, this.n29_1, this.o29_1, this.p29_1 + (this.l29_1 * delta.m25_1 + this.n29_1 * delta.n25_1), this.q29_1 + (this.m29_1 * delta.m25_1 + this.o29_1 * delta.n25_1));
  }
  o2a(deltaX, deltaY) {
    return this.n2a(Vector2D.j28(deltaX, deltaY));
  }
  p2a(deltaX, deltaY) {
    return this.n2a(Vector2D.q2a(deltaX, deltaY));
  }
  r2a(deltaX, deltaY) {
    return this.n2a(Vector2D.w27(deltaX, deltaY));
  }
  s2a(m) {
    return m.u29(this);
  }
  t2a() {
    if (this.b26())
      return Companion_getInstance_7().g29_1;
    var m = this;
    var norm = m.l29_1 * m.o29_1 - m.m29_1 * m.n29_1;
    var tmp;
    if (norm === 0.0) {
      tmp = new Matrix(0.0, 0.0, 0.0, 0.0, -m.p29_1, -m.q29_1);
    } else {
      var inorm = 1.0 / norm;
      var d = m.l29_1 * inorm;
      var a = m.o29_1 * inorm;
      var b = m.m29_1 * -inorm;
      var c = m.n29_1 * -inorm;
      tmp = new Matrix(a, b, c, d, -a * m.p29_1 - c * m.q29_1, -b * m.p29_1 - d * m.q29_1);
    }
    return tmp;
  }
  u2a() {
    return this.v2a();
  }
  v2a() {
    return Companion_getInstance_8().x2a(this);
  }
  toString() {
    return 'Matrix(' + get_niceStr(this.l29_1) + ', ' + get_niceStr(this.m29_1) + ', ' + get_niceStr(this.n29_1) + ', ' + get_niceStr(this.o29_1) + ', ' + get_niceStr(this.p29_1) + ', ' + get_niceStr(this.q29_1) + ')';
  }
  y2a(other, epsilon) {
    return Companion_getInstance_7().k29(this, other, epsilon);
  }
  ex(other, epsilon) {
    return this.y2a(other instanceof Matrix ? other : THROW_CCE(), epsilon);
  }
  z2a(other) {
    return this.u29(other);
  }
  hashCode() {
    var result = getNumberHashCode(this.l29_1);
    result = imul(result, 31) + getNumberHashCode(this.m29_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.n29_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.o29_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.p29_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.q29_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Matrix))
      return false;
    var tmp0_other_with_cast = other instanceof Matrix ? other : THROW_CCE();
    if (!equals(this.l29_1, tmp0_other_with_cast.l29_1))
      return false;
    if (!equals(this.m29_1, tmp0_other_with_cast.m29_1))
      return false;
    if (!equals(this.n29_1, tmp0_other_with_cast.n29_1))
      return false;
    if (!equals(this.o29_1, tmp0_other_with_cast.o29_1))
      return false;
    if (!equals(this.p29_1, tmp0_other_with_cast.p29_1))
      return false;
    if (!equals(this.q29_1, tmp0_other_with_cast.q29_1))
      return false;
    return true;
  }
}
class MatrixType extends Enum {
  constructor(name, ordinal, id, hasRotation, hasScale, hasTranslation) {
    super(name, ordinal);
    this.c2b_1 = id;
    this.d2b_1 = hasRotation;
    this.e2b_1 = hasScale;
    this.f2b_1 = hasTranslation;
  }
}
class Companion_8 {
  constructor() {
    Companion_instance_8 = this;
    this.w2a_1 = MatrixTransform.n2b(0.0, 0.0, 1.0, 1.0, Companion_getInstance_0().d25_1, Companion_getInstance_0().d25_1, Companion_getInstance_0().d25_1);
  }
  o2b(matrix, pivotX, pivotY) {
    var a = matrix.l29_1;
    var b = matrix.m29_1;
    var c = matrix.n29_1;
    var d = matrix.o29_1;
    // Inline function 'kotlin.math.atan2' call
    var y = -c;
    var skewX = -Math.atan2(y, d);
    // Inline function 'kotlin.math.atan2' call
    var skewY = Math.atan2(b, a);
    // Inline function 'kotlin.math.abs' call
    var x = skewX + skewY;
    var delta = Math.abs(x);
    var trotation;
    var tskewX;
    var tskewY;
    var tx;
    var ty;
    var tmp;
    if (delta < 0.001) {
      tmp = true;
    } else {
      // Inline function 'kotlin.math.abs' call
      var x_0 = 3.141592653589793 * 2 - delta;
      tmp = Math.abs(x_0) < 0.001;
    }
    if (tmp) {
      trotation = get_radians_0(skewY);
      tskewX = get_radians_0(0.0);
      tskewY = get_radians_0(0.0);
    } else {
      trotation = get_radians(0);
      tskewX = get_radians_0(skewX);
      tskewY = get_radians_0(skewY);
    }
    // Inline function 'kotlin.math.hypot' call
    var tscaleX = hypot(a, b);
    // Inline function 'kotlin.math.hypot' call
    var tscaleY = hypot(c, d);
    if (pivotX === 0.0 && pivotY === 0.0) {
      tx = matrix.p29_1;
      ty = matrix.q29_1;
    } else {
      tx = matrix.p29_1 + (pivotX * a + pivotY * c);
      ty = matrix.q29_1 + (pivotX * b + pivotY * d);
    }
    return MatrixTransform.n2b(tx, ty, tscaleX, tscaleY, tskewX, tskewY, trotation);
  }
  x2a(matrix, pivotX, pivotY, $super) {
    pivotX = pivotX === VOID ? 0.0 : pivotX;
    pivotY = pivotY === VOID ? 0.0 : pivotY;
    return $super === VOID ? this.o2b(matrix, pivotX, pivotY) : $super.o2b.call(this, matrix, pivotX, pivotY);
  }
  p2b(a, b, epsilon) {
    return isAlmostEquals(a.g2b_1, b.g2b_1, epsilon) && isAlmostEquals(a.h2b_1, b.h2b_1, epsilon) && isAlmostEquals(a.i2b_1, b.i2b_1, epsilon) && isAlmostEquals(a.j2b_1, b.j2b_1, epsilon) && Angle__isAlmostEquals_impl_201sgt(a.k2b_1, b.k2b_1, epsilon) && Angle__isAlmostEquals_impl_201sgt(a.l2b_1, b.l2b_1, epsilon) && Angle__isAlmostEquals_impl_201sgt(a.m2b_1, b.m2b_1, epsilon);
  }
}
class MatrixTransform {
  static n2b(x, y, scaleX, scaleY, skewX, skewY, rotation) {
    Companion_getInstance_8();
    x = x === VOID ? 0.0 : x;
    y = y === VOID ? 0.0 : y;
    scaleX = scaleX === VOID ? 1.0 : scaleX;
    scaleY = scaleY === VOID ? 1.0 : scaleY;
    skewX = skewX === VOID ? Companion_getInstance_0().d25_1 : skewX;
    skewY = skewY === VOID ? Companion_getInstance_0().d25_1 : skewY;
    rotation = rotation === VOID ? Companion_getInstance_0().d25_1 : rotation;
    var $this = createThis(this);
    $this.g2b_1 = x;
    $this.h2b_1 = y;
    $this.i2b_1 = scaleX;
    $this.j2b_1 = scaleY;
    $this.k2b_1 = skewX;
    $this.l2b_1 = skewY;
    $this.m2b_1 = rotation;
    return $this;
  }
  toString() {
    return 'MatrixTransform(x=' + get_niceStr(this.g2b_1) + ', y=' + get_niceStr(this.h2b_1) + ', scaleX=' + this.i2b_1 + ', scaleY=' + this.j2b_1 + ', skewX=' + Angle__toString_impl_786qky(this.k2b_1) + ', skewY=' + Angle__toString_impl_786qky(this.l2b_1) + ', rotation=' + Angle__toString_impl_786qky(this.m2b_1) + ')';
  }
  static q2b() {
    Companion_getInstance_8();
    return this.n2b(0.0, 0.0, 1.0, 1.0, Companion_getInstance_0().d25_1, Companion_getInstance_0().d25_1, Companion_getInstance_0().d25_1);
  }
  r2b(other, epsilon) {
    return Companion_getInstance_8().p2b(this, other, epsilon);
  }
  ex(other, epsilon) {
    return this.r2b(other instanceof MatrixTransform ? other : THROW_CCE(), epsilon);
  }
  s2b() {
    return (this.i2b_1 + this.j2b_1) * 0.5;
  }
  hashCode() {
    var result = getNumberHashCode(this.g2b_1);
    result = imul(result, 31) + getNumberHashCode(this.h2b_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.i2b_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.j2b_1) | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.k2b_1) | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.l2b_1) | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.m2b_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MatrixTransform))
      return false;
    var tmp0_other_with_cast = other instanceof MatrixTransform ? other : THROW_CCE();
    if (!equals(this.g2b_1, tmp0_other_with_cast.g2b_1))
      return false;
    if (!equals(this.h2b_1, tmp0_other_with_cast.h2b_1))
      return false;
    if (!equals(this.i2b_1, tmp0_other_with_cast.i2b_1))
      return false;
    if (!equals(this.j2b_1, tmp0_other_with_cast.j2b_1))
      return false;
    if (!equals(this.k2b_1, tmp0_other_with_cast.k2b_1))
      return false;
    if (!equals(this.l2b_1, tmp0_other_with_cast.l2b_1))
      return false;
    if (!equals(this.m2b_1, tmp0_other_with_cast.m2b_1))
      return false;
    return true;
  }
}
class Companion_9 {
  constructor() {
    Companion_instance_9 = this;
    this.t2b_1 = 0;
    this.u2b_1 = 1;
    this.v2b_1 = 2;
    this.w2b_1 = 3;
    this.x2b_1 = 4;
    this.y2b_1 = 5;
    this.z2b_1 = 6;
    this.a2c_1 = 7;
    this.b2c_1 = 8;
    this.c2c_1 = 9;
    this.d2c_1 = 10;
    this.e2c_1 = 11;
    this.f2c_1 = 12;
    this.g2c_1 = 13;
    this.h2c_1 = 14;
    this.i2c_1 = 15;
    var tmp = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp.j2c_1 = new Int32Array([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]);
    var tmp_0 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_0.k2c_1 = new Int32Array([0, 4, 8, 12, 1, 5, 9, 13, 2, 6, 10, 14, 3, 7, 11, 15]);
    var tmp_1 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_1.l2c_1 = new Int32Array([0, 1, 2, 4, 5, 6, 8, 9, 10]);
    var tmp_2 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_2.m2c_1 = new Int32Array([0, 4, 8, 1, 5, 9, 2, 6, 10]);
    this.n2c_1 = Matrix4.p2c();
  }
  q2c(v00, v01, v02, v03, v10, v11, v12, v13, v20, v21, v22, v23, v30, v31, v32, v33) {
    return Matrix4.r2c(v00, v10, v20, v30, v01, v11, v21, v31, v02, v12, v22, v32, v03, v13, v23, v33);
  }
  s2c(l, r) {
    return Companion_getInstance_9().q2c(l.t2c() * r.t2c() + l.u2c() * r.v2c() + l.w2c() * r.x2c() + l.y2c() * r.z2c(), l.t2c() * r.u2c() + l.u2c() * r.a2d() + l.w2c() * r.b2d() + l.y2c() * r.c2d(), l.t2c() * r.w2c() + l.u2c() * r.d2d() + l.w2c() * r.e2d() + l.y2c() * r.f2d(), l.t2c() * r.y2c() + l.u2c() * r.g2d() + l.w2c() * r.h2d() + l.y2c() * r.i2d(), l.v2c() * r.t2c() + l.a2d() * r.v2c() + l.d2d() * r.x2c() + l.g2d() * r.z2c(), l.v2c() * r.u2c() + l.a2d() * r.a2d() + l.d2d() * r.b2d() + l.g2d() * r.c2d(), l.v2c() * r.w2c() + l.a2d() * r.d2d() + l.d2d() * r.e2d() + l.g2d() * r.f2d(), l.v2c() * r.y2c() + l.a2d() * r.g2d() + l.d2d() * r.h2d() + l.g2d() * r.i2d(), l.x2c() * r.t2c() + l.b2d() * r.v2c() + l.e2d() * r.x2c() + l.h2d() * r.z2c(), l.x2c() * r.u2c() + l.b2d() * r.a2d() + l.e2d() * r.b2d() + l.h2d() * r.c2d(), l.x2c() * r.w2c() + l.b2d() * r.d2d() + l.e2d() * r.e2d() + l.h2d() * r.f2d(), l.x2c() * r.y2c() + l.b2d() * r.g2d() + l.e2d() * r.h2d() + l.h2d() * r.i2d(), l.z2c() * r.t2c() + l.c2d() * r.v2c() + l.f2d() * r.x2c() + l.i2d() * r.z2c(), l.z2c() * r.u2c() + l.c2d() * r.a2d() + l.f2d() * r.b2d() + l.i2d() * r.c2d(), l.z2c() * r.w2c() + l.c2d() * r.d2d() + l.f2d() * r.e2d() + l.i2d() * r.f2d(), l.z2c() * r.y2c() + l.c2d() * r.g2d() + l.f2d() * r.h2d() + l.i2d() * r.i2d());
  }
  j2d(left, right, bottom, top, near, far) {
    var sx = 2.0 / (right - left);
    var sy = 2.0 / (top - bottom);
    var sz = -2.0 / (far - near);
    var tx = -(right + left) / (right - left);
    var ty = -(top + bottom) / (top - bottom);
    var tz = -(far + near) / (far - near);
    return Companion_getInstance_9().q2c(sx, 0.0, 0.0, tx, 0.0, sy, 0.0, ty, 0.0, 0.0, sz, tz, 0.0, 0.0, 0.0, 1.0);
  }
  k2d(left, right, bottom, top, near, far) {
    return this.j2d(left, right, bottom, top, near, far);
  }
}
class Matrix4 {
  static l2d(data) {
    Companion_getInstance_9();
    var $this = createThis(this);
    $this.o2c_1 = data;
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!($this.o2c_1.length === 16)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.z4(toString(message));
    }
    return $this;
  }
  t2c() {
    return this.o2c_1[0];
  }
  v2c() {
    return this.o2c_1[1];
  }
  x2c() {
    return this.o2c_1[2];
  }
  z2c() {
    return this.o2c_1[3];
  }
  u2c() {
    return this.o2c_1[4];
  }
  a2d() {
    return this.o2c_1[5];
  }
  b2d() {
    return this.o2c_1[6];
  }
  c2d() {
    return this.o2c_1[7];
  }
  w2c() {
    return this.o2c_1[8];
  }
  d2d() {
    return this.o2c_1[9];
  }
  e2d() {
    return this.o2c_1[10];
  }
  f2d() {
    return this.o2c_1[11];
  }
  y2c() {
    return this.o2c_1[12];
  }
  g2d() {
    return this.o2c_1[13];
  }
  h2d() {
    return this.o2c_1[14];
  }
  i2d() {
    return this.o2c_1[15];
  }
  equals(other) {
    var tmp;
    if (other instanceof Matrix4) {
      tmp = contentEquals(this.o2c_1, other.o2c_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return contentHashCode(this.o2c_1);
  }
  m2d(that) {
    return Companion_getInstance_9().s2c(this, that);
  }
  static r2c(v00, v10, v20, v30, v01, v11, v21, v31, v02, v12, v22, v32, v03, v13, v23, v33) {
    Companion_getInstance_9();
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$0 = new Float32Array([v00, v10, v20, v30, v01, v11, v21, v31, v02, v12, v22, v32, v03, v13, v23, v33]);
    return this.l2d(tmp$ret$0);
  }
  static p2c() {
    Companion_getInstance_9();
    return this.r2c(1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0);
  }
  y27(row, column) {
    if (!(0 <= column ? column <= 3 : false) || !(0 <= row ? row <= 3 : false)) {
      // Inline function 'kotlin.error' call
      var message = 'Invalid index ' + row + ',' + column;
      throw IllegalStateException.z4(toString(message));
    }
    return this.o2c_1[imul(row, 4) + column | 0];
  }
  n2d(index) {
    if (!(0 <= index ? index <= (this.o2c_1.length - 1 | 0) : false)) {
      // Inline function 'kotlin.error' call
      var message = 'Invalid index ' + index;
      throw IllegalStateException.z4(toString(message));
    }
    return this.o2c_1[index];
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.Matrix4.toString.<anonymous>' call
    this_0.tb('Matrix4(\n');
    var inductionVariable = 0;
    if (inductionVariable < 4)
      do {
        var row = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this_0.tb('  [ ');
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 4)
          do {
            var col = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            if (!(col === 0)) {
              this_0.tb(', ');
            }
            var v = this.y27(row, col);
            // Inline function 'kotlin.math.floor' call
            if (Math.floor(v) === v)
              this_0.sg(numberToInt(v));
            else {
              this_0.ug(v);
            }
          }
           while (inductionVariable_0 < 4);
        this_0.tb(' ],\n');
      }
       while (inductionVariable < 4);
    this_0.tb(')');
    return this_0.toString();
  }
}
class Companion_10 {
  constructor() {
    this.k25_1 = 1.0E-7;
  }
  l25(up) {
    // Inline function 'kotlin.check' call
    var tmp;
    if (up.m25_1 === 0.0) {
      // Inline function 'kotlin.math.absoluteValue' call
      var this_0 = up.n25_1;
      tmp = Math.abs(this_0) === 1.0;
    } else {
      tmp = false;
    }
    // Inline function 'kotlin.contracts.contract' call
    if (!tmp) {
      // Inline function 'korlibs.math.geom.Companion.checkValidUpVector.<anonymous>' call
      var message = 'up vector only supports (0, -1) and (0, +1) for now';
      throw IllegalStateException.z4(toString(message));
    }
  }
}
class Orientation extends Enum {
  constructor(name, ordinal, value) {
    super(name, ordinal);
    this.t2d_1 = value;
  }
}
class Companion_11 {
  constructor() {
    Companion_instance_11 = this;
    var tmp = this;
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_11();
    tmp.u2d_1 = new RectCorners(numberToDouble(0), numberToDouble(0), numberToDouble(0), numberToDouble(0));
    var tmp_0 = this;
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_11();
    tmp_0.v2d_1 = new RectCorners(numberToDouble(0), numberToDouble(0), numberToDouble(0), numberToDouble(0));
    var tmp_1 = this;
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_11();
    tmp_1.w2d_1 = new RectCorners(numberToDouble(1.0), numberToDouble(1.0), numberToDouble(1.0), numberToDouble(1.0));
    var tmp_2 = this;
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_11();
    var corner = -1.0;
    tmp_2.x2d_1 = new RectCorners(numberToDouble(corner), numberToDouble(corner), numberToDouble(corner), numberToDouble(corner));
    var tmp_3 = this;
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_11();
    tmp_3.y2d_1 = new RectCorners(numberToDouble(NaN), numberToDouble(NaN), numberToDouble(NaN), numberToDouble(NaN));
  }
}
class RectCorners {
  constructor(topLeft, topRight, bottomRight, bottomLeft) {
    Companion_getInstance_11();
    this.z2d_1 = topLeft;
    this.a2e_1 = topRight;
    this.b2e_1 = bottomRight;
    this.c2e_1 = bottomLeft;
  }
  d2e(scale) {
    return new RectCorners(this.z2d_1 * scale, this.a2e_1 * scale, this.b2e_1 * scale, this.c2e_1 * scale);
  }
  toString() {
    return 'RectCorners(topLeft=' + this.z2d_1 + ', topRight=' + this.a2e_1 + ', bottomRight=' + this.b2e_1 + ', bottomLeft=' + this.c2e_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.z2d_1);
    result = imul(result, 31) + getNumberHashCode(this.a2e_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.b2e_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.c2e_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RectCorners))
      return false;
    var tmp0_other_with_cast = other instanceof RectCorners ? other : THROW_CCE();
    if (!equals(this.z2d_1, tmp0_other_with_cast.z2d_1))
      return false;
    if (!equals(this.a2e_1, tmp0_other_with_cast.a2e_1))
      return false;
    if (!equals(this.b2e_1, tmp0_other_with_cast.b2e_1))
      return false;
    if (!equals(this.c2e_1, tmp0_other_with_cast.c2e_1))
      return false;
    return true;
  }
}
class Companion_12 {
  constructor() {
    Companion_instance_12 = this;
    this.i26_1 = Companion_getInstance_12().e2e(0, 0, 0, 0);
    this.j26_1 = Companion_getInstance_12().f2e(-Infinity, -Infinity, Infinity, Infinity);
    this.k26_1 = Companion_getInstance_12().f2e(NaN, NaN, 0.0, 0.0);
  }
  l26() {
    return this.k26_1;
  }
  j29() {
    return this.i26_1;
  }
  u26(p, s) {
    return new Rectangle(p.m25_1, p.n25_1, s.r26_1, s.s26_1);
  }
  e2e(x, y, width, height) {
    return Companion_getInstance_12().u26(Vector2D.j28(x, y), Size2D.t26(width, height));
  }
  f2e(x, y, width, height) {
    return Companion_getInstance_12().u26(Vector2D.q2a(x, y), Size2D.g2e(width, height));
  }
  h2e(left, top, right, bottom) {
    return new Rectangle(left, top, right - left, bottom - top);
  }
  i2e(left, top, right, bottom) {
    return this.h2e(left, top, right, bottom);
  }
  q26(point1, point2) {
    var tmp = Companion_getInstance_12();
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var tmp$ret$0 = Vector2D.w27(point2.m25_1 - point1.m25_1, point2.n25_1 - point1.n25_1);
    return tmp.u26(point1, toSize(tmp$ret$0));
  }
  j2e(a, b) {
    return a.w25_1 >= b.w25_1 && a.x25_1 >= b.x25_1 && a.w25_1 + a.y25_1 <= b.w25_1 + b.y25_1 && a.x25_1 + a.z25_1 <= b.x25_1 + b.z25_1;
  }
}
class Rectangle {
  constructor(x, y, width, height) {
    Companion_getInstance_12();
    this.w25_1 = x;
    this.x25_1 = y;
    this.y25_1 = width;
    this.z25_1 = height;
    this.a26_1 = true;
  }
  wx() {
    return this;
  }
  k2e() {
    return this;
  }
  e1() {
    return Size2D.l2e(this.y25_1, this.z25_1);
  }
  m2e() {
    return isNaN_0(this.w25_1);
  }
  b26() {
    return this.m2e();
  }
  c26() {
    return !this.b26();
  }
  n2e(other, epsilon) {
    return isAlmostEquals(this.w25_1, other.w25_1, epsilon) && isAlmostEquals(this.x25_1, other.x25_1, epsilon) && isAlmostEquals(this.y25_1, other.y25_1, epsilon) && isAlmostEquals(this.z25_1, other.z25_1, epsilon);
  }
  ex(other, epsilon) {
    return this.n2e(other instanceof Rectangle ? other : THROW_CCE(), epsilon);
  }
  toString() {
    return this.b26() ? 'null' : 'Rectangle(x=' + get_niceStr(this.w25_1) + ', y=' + get_niceStr(this.x25_1) + ', width=' + get_niceStr(this.y25_1) + ', height=' + get_niceStr(this.z25_1) + ')';
  }
  d2e(scale) {
    return new Rectangle(this.w25_1 * scale, this.x25_1 * scale, this.y25_1 * scale, this.z25_1 * scale);
  }
  s27(that) {
    return this.o2e(that.m25_1, that.n25_1);
  }
  p2e(that) {
    return this.s2e(that.q2e_1, that.r2e_1);
  }
  o2e(x, y) {
    return x >= this.d26() && x < this.e26() && (y >= this.f26() && y < this.g26());
  }
  s2e(x, y) {
    return this.o2e(x, y);
  }
  d26() {
    return this.w25_1;
  }
  f26() {
    return this.x25_1;
  }
  e26() {
    return this.w25_1 + this.y25_1;
  }
  g26() {
    return this.x25_1 + this.z25_1;
  }
  v26() {
    return Vector2D.w27(this.d26(), this.f26());
  }
  t2e() {
    return Vector2D.w27(this.e26(), this.f26());
  }
  u2e() {
    return Vector2D.w27(this.d26(), this.g26());
  }
  x26() {
    return Vector2D.w27(this.e26(), this.g26());
  }
  v2e() {
    return (this.e26() + this.d26()) * 0.5;
  }
  w2e() {
    return (this.g26() + this.f26()) * 0.5;
  }
  x2e() {
    return Vector2D.w27(this.v2e(), this.w2e());
  }
  y2e(padding) {
    return Companion_getInstance_12().h2e(this.d26() + padding.s28_1, this.f26() + padding.p28_1, this.e26() - padding.q28_1, this.g26() - padding.r28_1);
  }
  z2e(that) {
    return this.a2f(that) && this.b2f(that);
  }
  a2f(that) {
    return that.d26() <= this.e26() && that.e26() >= this.d26();
  }
  b2f(that) {
    return that.f26() <= this.g26() && that.g26() >= this.f26();
  }
  c2f(that) {
    var tmp;
    if (this.z2e(that)) {
      // Inline function 'kotlin.math.max' call
      var a = this.d26();
      var b = that.d26();
      var tmp_0 = Math.max(a, b);
      // Inline function 'kotlin.math.max' call
      var a_0 = this.f26();
      var b_0 = that.f26();
      var tmp_1 = Math.max(a_0, b_0);
      // Inline function 'kotlin.math.min' call
      var a_1 = this.e26();
      var b_1 = that.e26();
      var tmp_2 = Math.min(a_1, b_1);
      // Inline function 'kotlin.math.min' call
      var a_2 = this.g26();
      var b_2 = that.g26();
      var tmp$ret$3 = Math.min(a_2, b_2);
      tmp = new Rectangle(tmp_0, tmp_1, tmp_2, tmp$ret$3);
    } else {
      tmp = Companion_getInstance_12().l26();
    }
    return tmp;
  }
  l2() {
    return RectangleInt.h2f(numberToInt(this.w25_1), numberToInt(this.x25_1), numberToInt(this.y25_1), numberToInt(this.z25_1));
  }
  i2f(border) {
    return Companion_getInstance_12().h2e(this.d26() - border.c29_1, this.f26() - border.z28_1, this.e26() + border.a29_1, this.g26() + border.b29_1);
  }
  k2a(delta) {
    return this.j2f(this.w25_1 + delta.m25_1, this.x25_1 + delta.n25_1);
  }
  k2f(m) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p = this.v26();
      if (m.b26()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.w27(m.y29(p.m25_1, p.n25_1), m.b2a(p.m25_1, p.n25_1));
    }
    var tl = tmp$ret$0;
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p_0 = this.t2e();
      if (m.b26()) {
        tmp$ret$1 = p_0;
        break $l$block_0;
      }
      tmp$ret$1 = Vector2D.w27(m.y29(p_0.m25_1, p_0.n25_1), m.b2a(p_0.m25_1, p_0.n25_1));
    }
    var tr = tmp$ret$1;
    var tmp$ret$2;
    $l$block_1: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p_1 = this.u2e();
      if (m.b26()) {
        tmp$ret$2 = p_1;
        break $l$block_1;
      }
      tmp$ret$2 = Vector2D.w27(m.y29(p_1.m25_1, p_1.n25_1), m.b2a(p_1.m25_1, p_1.n25_1));
    }
    var bl = tmp$ret$2;
    var tmp$ret$3;
    $l$block_2: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p_2 = this.x26();
      if (m.b26()) {
        tmp$ret$3 = p_2;
        break $l$block_2;
      }
      tmp$ret$3 = Vector2D.w27(m.y29(p_2.m25_1, p_2.n25_1), m.b2a(p_2.m25_1, p_2.n25_1));
    }
    var br = tmp$ret$3;
    var min = Companion_getInstance_17().o26(tl, tr, bl, br);
    var max = Companion_getInstance_17().p26(tl, tr, bl, br);
    return Companion_getInstance_12().q26(min, max);
  }
  l2f() {
    return Companion_getInstance_12().q26(Companion_getInstance_17().w26(this.v26(), this.x26()), Companion_getInstance_17().y26(this.v26(), this.x26()));
  }
  m2f(x, y, width, height) {
    return new Rectangle(x, y, width, height);
  }
  j2f(x, y, width, height, $super) {
    x = x === VOID ? this.w25_1 : x;
    y = y === VOID ? this.x25_1 : y;
    width = width === VOID ? this.y25_1 : width;
    height = height === VOID ? this.z25_1 : height;
    return $super === VOID ? this.m2f(x, y, width, height) : $super.m2f.call(this, x, y, width, height);
  }
  hashCode() {
    var result = getNumberHashCode(this.w25_1);
    result = imul(result, 31) + getNumberHashCode(this.x25_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.y25_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.z25_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Rectangle))
      return false;
    var tmp0_other_with_cast = other instanceof Rectangle ? other : THROW_CCE();
    if (!equals(this.w25_1, tmp0_other_with_cast.w25_1))
      return false;
    if (!equals(this.x25_1, tmp0_other_with_cast.x25_1))
      return false;
    if (!equals(this.y25_1, tmp0_other_with_cast.y25_1))
      return false;
    if (!equals(this.z25_1, tmp0_other_with_cast.z25_1))
      return false;
    return true;
  }
}
class Companion_13 {
  o2f(a, b) {
    // Inline function 'kotlin.math.min' call
    var a_0 = a.d26();
    var b_0 = b.d26();
    var tmp = Math.min(a_0, b_0);
    // Inline function 'kotlin.math.min' call
    var a_1 = a.f26();
    var b_1 = b.f26();
    var tmp_0 = Math.min(a_1, b_1);
    // Inline function 'kotlin.math.max' call
    var a_2 = a.e26();
    var b_2 = b.e26();
    var tmp_1 = Math.max(a_2, b_2);
    // Inline function 'kotlin.math.max' call
    var a_3 = a.g26();
    var b_3 = b.g26();
    var tmp$ret$3 = Math.max(a_3, b_3);
    return this.i2e(tmp, tmp_0, tmp_1, tmp$ret$3);
  }
  p2f(topLeft, bottomRight) {
    var size = bottomRight.s2f(topLeft);
    return RectangleInt.h2f(topLeft.q2f_1, topLeft.r2f_1, size.q2f_1, size.r2f_1);
  }
  i2e(left, top, right, bottom) {
    return this.p2f(Vector2I.t2f(left, top), Vector2I.t2f(right, bottom));
  }
}
class RectangleInt {
  static h2f(x, y, width, height) {
    var $this = createThis(this);
    $this.d2f_1 = x;
    $this.e2f_1 = y;
    $this.f2f_1 = width;
    $this.g2f_1 = height;
    return $this;
  }
  static u2f() {
    return this.h2f(0, 0, 0, 0);
  }
  v2f() {
    return imul(this.f2f_1, this.g2f_1);
  }
  d26() {
    return this.d2f_1;
  }
  f26() {
    return this.e2f_1;
  }
  e26() {
    return this.d2f_1 + this.f2f_1 | 0;
  }
  g26() {
    return this.e2f_1 + this.g2f_1 | 0;
  }
  w2f(left, top, right, bottom, clamped) {
    var left_0 = !clamped ? left : coerceIn(left, 0, this.f2f_1);
    var right_0 = !clamped ? right : coerceIn(right, 0, this.f2f_1);
    var top_0 = !clamped ? top : coerceIn(top, 0, this.g2f_1);
    var bottom_0 = !clamped ? bottom : coerceIn(bottom, 0, this.g2f_1);
    return Companion_instance_13.i2e(this.d2f_1 + left_0 | 0, this.e2f_1 + top_0 | 0, this.d2f_1 + right_0 | 0, this.e2f_1 + bottom_0 | 0);
  }
  toString() {
    return 'Rectangle(x=' + this.d2f_1 + ', y=' + this.e2f_1 + ', width=' + this.f2f_1 + ', height=' + this.g2f_1 + ')';
  }
  x2f() {
    return Companion_getInstance_12().e2e(this.d2f_1, this.e2f_1, this.f2f_1, this.g2f_1);
  }
  i2f(border) {
    return Companion_instance_13.i2e(this.d26() - border.c29_1 | 0, this.f26() - border.z28_1 | 0, this.e26() + border.a29_1 | 0, this.g26() + border.b29_1 | 0);
  }
  hashCode() {
    var result = this.d2f_1;
    result = imul(result, 31) + this.e2f_1 | 0;
    result = imul(result, 31) + this.f2f_1 | 0;
    result = imul(result, 31) + this.g2f_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RectangleInt))
      return false;
    var tmp0_other_with_cast = other instanceof RectangleInt ? other : THROW_CCE();
    if (!(this.d2f_1 === tmp0_other_with_cast.d2f_1))
      return false;
    if (!(this.e2f_1 === tmp0_other_with_cast.e2f_1))
      return false;
    if (!(this.f2f_1 === tmp0_other_with_cast.f2f_1))
      return false;
    if (!(this.g2f_1 === tmp0_other_with_cast.g2f_1))
      return false;
    return true;
  }
}
class Companion_14 {
  constructor() {
    Companion_instance_14 = this;
    this.y2f_1 = Scale.z2f(1.0, 1.0);
  }
}
class Scale {
  static q2d(scaleX, scaleY) {
    Companion_getInstance_14();
    var $this = createThis(this);
    $this.o2d_1 = scaleX;
    $this.p2d_1 = scaleY;
    return $this;
  }
  s2b() {
    return this.o2d_1 * 0.5 + this.p2d_1 * 0.5;
  }
  static a2g() {
    Companion_getInstance_14();
    return this.z2f(1.0, 1.0);
  }
  static b2g(scale) {
    Companion_getInstance_14();
    return this.q2d(scale, scale);
  }
  static c2g(scale) {
    Companion_getInstance_14();
    return this.b2g(scale);
  }
  static z2f(scaleX, scaleY) {
    Companion_getInstance_14();
    return this.q2d(scaleX, scaleY);
  }
  static d2g(scaleX, scaleY) {
    Companion_getInstance_14();
    return this.q2d(scaleX, scaleY);
  }
  toString() {
    return 'Scale(scaleX=' + this.o2d_1 + ', scaleY=' + this.p2d_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.o2d_1);
    result = imul(result, 31) + getNumberHashCode(this.p2d_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Scale))
      return false;
    var tmp0_other_with_cast = other instanceof Scale ? other : THROW_CCE();
    if (!equals(this.o2d_1, tmp0_other_with_cast.o2d_1))
      return false;
    if (!equals(this.p2d_1, tmp0_other_with_cast.p2d_1))
      return false;
    return true;
  }
}
class Companion_15 {
  constructor() {
    Companion_instance_15 = this;
    var tmp = this;
    tmp.h2g_1 = new ScaleMode('COVER', ScaleMode$Companion$COVER$lambda);
    var tmp_0 = this;
    tmp_0.i2g_1 = new ScaleMode('SHOW_ALL', ScaleMode$Companion$SHOW_ALL$lambda);
    var tmp_1 = this;
    tmp_1.j2g_1 = new ScaleMode('EXACT', ScaleMode$Companion$EXACT$lambda);
    var tmp_2 = this;
    tmp_2.k2g_1 = new ScaleMode('NO_SCALE', ScaleMode$Companion$NO_SCALE$lambda);
  }
  l2g() {
    return this.j2g_1;
  }
}
class ScaleMode {
  constructor(name, transform) {
    Companion_getInstance_15();
    name = name === VOID ? null : name;
    this.m2g_1 = name;
    this.n2g_1 = transform;
  }
  toString() {
    return 'ScaleMode(' + this.m2g_1 + ')';
  }
  o2g(item, container) {
    return toInt(this.n2g_1(toFloat(item), toFloat(container)));
  }
}
class Companion_16 {
  constructor() {
    Companion_instance_16 = this;
    this.p2g_1 = Size2D.l2e(0.0, 0.0);
  }
}
class Size2D {
  static l2e(width, height) {
    Companion_getInstance_16();
    var $this = createThis(this);
    $this.r26_1 = width;
    $this.s26_1 = height;
    return $this;
  }
  static q2g() {
    Companion_getInstance_16();
    return this.l2e(0.0, 0.0);
  }
  static g2e(width, height) {
    Companion_getInstance_16();
    return this.l2e(width, height);
  }
  static t26(width, height) {
    Companion_getInstance_16();
    return this.l2e(width, height);
  }
  r2g(scale) {
    return Size2D.l2e(this.r26_1 * scale.o2d_1, this.s26_1 * scale.p2d_1);
  }
  s2g(s) {
    return Size2D.l2e(this.r26_1 * s, this.s26_1 * s);
  }
  d2e(s) {
    return this.s2g(s);
  }
  e2g(other) {
    return Scale.q2d(this.r26_1 / other.r26_1, this.s26_1 / other.s26_1);
  }
  toString() {
    return 'Size(width=' + get_niceStr(this.r26_1) + ', height=' + get_niceStr(this.s26_1) + ')';
  }
  jl() {
    return this.r26_1;
  }
  kl() {
    return this.s26_1;
  }
  t2g(width, height) {
    return Size2D.l2e(width, height);
  }
  u2g(width, height, $super) {
    width = width === VOID ? this.r26_1 : width;
    height = height === VOID ? this.s26_1 : height;
    return $super === VOID ? this.t2g(width, height) : $super.t2g.call(this, width, height);
  }
  hashCode() {
    var result = getNumberHashCode(this.r26_1);
    result = imul(result, 31) + getNumberHashCode(this.s26_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Size2D))
      return false;
    var tmp0_other_with_cast = other instanceof Size2D ? other : THROW_CCE();
    if (!equals(this.r26_1, tmp0_other_with_cast.r26_1))
      return false;
    if (!equals(this.s26_1, tmp0_other_with_cast.s26_1))
      return false;
    return true;
  }
}
class SizeInt {
  static x2g(width, height) {
    var $this = createThis(this);
    $this.v2g_1 = width;
    $this.w2g_1 = height;
    return $this;
  }
  static y2g() {
    return this.x2g(0, 0);
  }
  toString() {
    return '' + this.v2g_1 + 'x' + this.w2g_1;
  }
  hashCode() {
    var result = this.v2g_1;
    result = imul(result, 31) + this.w2g_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SizeInt))
      return false;
    var tmp0_other_with_cast = other instanceof SizeInt ? other : THROW_CCE();
    if (!(this.v2g_1 === tmp0_other_with_cast.v2g_1))
      return false;
    if (!(this.w2g_1 === tmp0_other_with_cast.w2g_1))
      return false;
    return true;
  }
}
class Companion_17 {
  constructor() {
    Companion_instance_17 = this;
    this.o25_1 = Vector2D.w27(0.0, 0.0);
    this.p25_1 = Vector2D.w27(NaN, NaN);
    this.q25_1 = Vector2D.w27(-1.0, 0.0);
    this.r25_1 = Vector2D.w27(+1.0, 0.0);
    this.s25_1 = Vector2D.w27(0.0, +1.0);
    this.t25_1 = Vector2D.w27(0.0, -1.0);
    this.u25_1 = Vector2D.w27(0.0, -1.0);
    this.v25_1 = Vector2D.w27(0.0, +1.0);
  }
  z2g(a, b, up) {
    // Inline function 'korlibs.math.geom.Companion.between' call
    // Inline function 'korlibs.math.geom.Companion.between' call
    Companion_getInstance_0();
    var x0 = a.m25_1;
    var y0 = a.n25_1;
    var x1 = b.m25_1;
    var y1 = b.n25_1;
    return Angle_between(x0, y0, x1, y1, up);
  }
  a2h(a, b, up, $super) {
    up = up === VOID ? this.s25_1 : up;
    return $super === VOID ? this.z2g(a, b, up) : $super.z2g.call(this, a, b, up).b25_1;
  }
  n2f(x1, y1, x2, y2) {
    // Inline function 'kotlin.math.hypot' call
    var x = x1 - x2;
    var y = y1 - y2;
    return hypot(x, y);
  }
  b2h(x1, y1, x2, y2) {
    // Inline function 'kotlin.math.hypot' call
    var x = x1 - x2;
    var y = y1 - y2;
    return hypot(x, y);
  }
  c2h(x1, y1, x2, y2) {
    // Inline function 'kotlin.math.hypot' call
    var x = x1 - x2;
    var y = y1 - y2;
    return hypot(x, y);
  }
  d2h(a, b) {
    return this.n2f(a.m25_1, a.n25_1, b.m25_1, b.n25_1);
  }
  e27(a, b) {
    return this.e2h(a.m25_1, a.n25_1, b.m25_1, b.n25_1);
  }
  e2h(x1, y1, x2, y2) {
    return square(this, x1 - x2) + square(this, y1 - y2);
  }
  f2h(ax, ay, bx, by) {
    return ax * by - bx * ay;
  }
  g2h(p1, p2) {
    return this.f2h(p1.m25_1, p1.n25_1, p2.m25_1, p2.n25_1);
  }
  w26(p1, p2) {
    // Inline function 'kotlin.math.min' call
    var a = p1.m25_1;
    var b = p2.m25_1;
    var tmp = Math.min(a, b);
    // Inline function 'kotlin.math.min' call
    var a_0 = p1.n25_1;
    var b_0 = p2.n25_1;
    var tmp$ret$1 = Math.min(a_0, b_0);
    return Vector2D.w27(tmp, tmp$ret$1);
  }
  o26(p1, p2, p3, p4) {
    return Vector2D.w27(minOf(p1.m25_1, new Float64Array([p2.m25_1, p3.m25_1, p4.m25_1])), minOf(p1.n25_1, new Float64Array([p2.n25_1, p3.n25_1, p4.n25_1])));
  }
  y26(p1, p2) {
    // Inline function 'kotlin.math.max' call
    var a = p1.m25_1;
    var b = p2.m25_1;
    var tmp = Math.max(a, b);
    // Inline function 'kotlin.math.max' call
    var a_0 = p1.n25_1;
    var b_0 = p2.n25_1;
    var tmp$ret$1 = Math.max(a_0, b_0);
    return Vector2D.w27(tmp, tmp$ret$1);
  }
  p26(p1, p2, p3, p4) {
    return Vector2D.w27(maxOf(p1.m25_1, new Float64Array([p2.m25_1, p3.m25_1, p4.m25_1])), maxOf(p1.n25_1, new Float64Array([p2.n25_1, p3.n25_1, p4.n25_1])));
  }
}
class Vector2D {
  static w27(x, y) {
    Companion_getInstance_17();
    var $this = createThis(this);
    $this.m25_1 = x;
    $this.n25_1 = y;
    return $this;
  }
  static q2a(x, y) {
    Companion_getInstance_17();
    return this.w27(x, y);
  }
  static j28(x, y) {
    Companion_getInstance_17();
    return this.w27(x, y);
  }
  static h28() {
    Companion_getInstance_17();
    return this.w27(0.0, 0.0);
  }
  g2g() {
    // Inline function 'kotlin.math.min' call
    var a = this.m25_1;
    var b = this.n25_1;
    return Math.min(a, b);
  }
  f2g() {
    // Inline function 'kotlin.math.max' call
    var a = this.m25_1;
    var b = this.n25_1;
    return Math.max(a, b);
  }
  h2h(x, y) {
    // Inline function 'kotlin.math.hypot' call
    var x_0 = x - this.m25_1;
    var y_0 = y - this.n25_1;
    return hypot(x_0, y_0);
  }
  i2h(that) {
    return this.h2h(that.m25_1, that.n25_1);
  }
  a() {
    // Inline function 'kotlin.math.hypot' call
    var x = this.m25_1;
    var y = this.n25_1;
    return hypot(x, y);
  }
  j2h() {
    var x = this.m25_1;
    var y = this.n25_1;
    return x * x + y * y;
  }
  k2h() {
    // Inline function 'kotlin.math.hypot' call
    var x = this.m25_1;
    var y = this.n25_1;
    return hypot(x, y);
  }
  l2h() {
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var scale = 1.0 / this.k2h();
    return Vector2D.w27(this.m25_1 * scale, this.n25_1 * scale);
  }
  m2h() {
    return Vector2D.w27(-this.n25_1, this.m25_1);
  }
  n2h(other, epsilon) {
    return isAlmostEquals(this.m25_1, other.m25_1, epsilon) && isAlmostEquals(this.n25_1, other.n25_1, epsilon);
  }
  ex(other, epsilon) {
    return this.n2h(other instanceof Vector2D ? other : THROW_CCE(), epsilon);
  }
  o2h() {
    return '(' + get_niceStr(this.m25_1) + ', ' + get_niceStr(this.n25_1) + ')';
  }
  toString() {
    return this.o2h();
  }
  jl() {
    return this.m25_1;
  }
  kl() {
    return this.n25_1;
  }
  hashCode() {
    var result = getNumberHashCode(this.m25_1);
    result = imul(result, 31) + getNumberHashCode(this.n25_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Vector2D))
      return false;
    var tmp0_other_with_cast = other instanceof Vector2D ? other : THROW_CCE();
    if (!equals(this.m25_1, tmp0_other_with_cast.m25_1))
      return false;
    if (!equals(this.n25_1, tmp0_other_with_cast.n25_1))
      return false;
    return true;
  }
}
class Companion_18 {
  constructor() {
    Companion_instance_18 = this;
    this.p2h_1 = new Vector4F(0.0, 0.0, 0.0, 0.0);
    this.q2h_1 = new Vector4F(1.0, 1.0, 1.0, 1.0);
  }
}
class Vector4F {
  constructor(x, y, z, w) {
    Companion_getInstance_18();
    this.r2h_1 = x;
    this.s2h_1 = y;
    this.t2h_1 = z;
    this.u2h_1 = w;
  }
  toString() {
    return 'Vector4(' + get_niceStr_0(this.r2h_1) + ', ' + get_niceStr_0(this.s2h_1) + ', ' + get_niceStr_0(this.t2h_1) + ', ' + get_niceStr_0(this.u2h_1) + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.r2h_1);
    result = imul(result, 31) + getNumberHashCode(this.s2h_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.t2h_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.u2h_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Vector4F))
      return false;
    var tmp0_other_with_cast = other instanceof Vector4F ? other : THROW_CCE();
    if (!equals(this.r2h_1, tmp0_other_with_cast.r2h_1))
      return false;
    if (!equals(this.s2h_1, tmp0_other_with_cast.s2h_1))
      return false;
    if (!equals(this.t2h_1, tmp0_other_with_cast.t2h_1))
      return false;
    if (!equals(this.u2h_1, tmp0_other_with_cast.u2h_1))
      return false;
    return true;
  }
}
class Companion_19 {
  constructor() {
    Companion_instance_19 = this;
    this.v2h_1 = new Vector3F(NaN, NaN, NaN);
    this.w2h_1 = new Vector3F(0.0, 0.0, 0.0);
    this.x2h_1 = new Vector3F(1.0, 1.0, 1.0);
    this.y2h_1 = new Vector3F(0.0, 0.0, 1.0);
    this.z2h_1 = new Vector3F(0.0, 0.0, -1.0);
    this.a2i_1 = new Vector3F(-1.0, 0.0, 0.0);
    this.b2i_1 = new Vector3F(1.0, 0.0, 0.0);
    this.c2i_1 = new Vector3F(0.0, 1.0, 0.0);
    this.d2i_1 = new Vector3F(0.0, -1.0, 0.0);
  }
}
class Vector3F {
  constructor(x, y, z) {
    Companion_getInstance_19();
    this.e2i_1 = x;
    this.f2i_1 = y;
    this.g2i_1 = z;
  }
  toString() {
    return 'Vector3(' + get_niceStr_0(this.e2i_1) + ', ' + get_niceStr_0(this.f2i_1) + ', ' + get_niceStr_0(this.g2i_1) + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.e2i_1);
    result = imul(result, 31) + getNumberHashCode(this.f2i_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.g2i_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Vector3F))
      return false;
    var tmp0_other_with_cast = other instanceof Vector3F ? other : THROW_CCE();
    if (!equals(this.e2i_1, tmp0_other_with_cast.e2i_1))
      return false;
    if (!equals(this.f2i_1, tmp0_other_with_cast.f2i_1))
      return false;
    if (!equals(this.g2i_1, tmp0_other_with_cast.g2i_1))
      return false;
    return true;
  }
}
class Companion_20 {
  constructor() {
    Companion_instance_20 = this;
    this.h2i_1 = Vector2F.p2i(0.0, 0.0);
    this.i2i_1 = Vector2F.p2i(NaN, NaN);
    this.j2i_1 = Vector2F.p2i(-1.0, 0.0);
    this.k2i_1 = Vector2F.p2i(+1.0, 0.0);
    this.l2i_1 = Vector2F.p2i(0.0, +1.0);
    this.m2i_1 = Vector2F.p2i(0.0, -1.0);
    this.n2i_1 = Vector2F.p2i(0.0, -1.0);
    this.o2i_1 = Vector2F.p2i(0.0, +1.0);
  }
}
class Vector2F {
  static p2i(x, y) {
    Companion_getInstance_20();
    var $this = createThis(this);
    $this.q2e_1 = x;
    $this.r2e_1 = y;
    return $this;
  }
  static q2i(x, y) {
    Companion_getInstance_20();
    return this.p2i(x, y);
  }
  static r2i(x, y) {
    Companion_getInstance_20();
    return this.p2i(x, y);
  }
  static s2i() {
    Companion_getInstance_20();
    return this.p2i(0.0, 0.0);
  }
  o2h() {
    return '(' + get_niceStr_0(this.q2e_1) + ', ' + get_niceStr_0(this.r2e_1) + ')';
  }
  toString() {
    return this.o2h();
  }
  hashCode() {
    var result = getNumberHashCode(this.q2e_1);
    result = imul(result, 31) + getNumberHashCode(this.r2e_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Vector2F))
      return false;
    var tmp0_other_with_cast = other instanceof Vector2F ? other : THROW_CCE();
    if (!equals(this.q2e_1, tmp0_other_with_cast.q2e_1))
      return false;
    if (!equals(this.r2e_1, tmp0_other_with_cast.r2e_1))
      return false;
    return true;
  }
}
class Companion_21 {
  constructor() {
    Companion_instance_21 = this;
    this.t2i_1 = Vector2I.t2f(0, 0);
  }
}
class Vector2I {
  static t2f(x, y) {
    Companion_getInstance_21();
    var $this = createThis(this);
    $this.q2f_1 = x;
    $this.r2f_1 = y;
    return $this;
  }
  static u2i() {
    Companion_getInstance_21();
    return this.t2f(0, 0);
  }
  v2i(that) {
    return Vector2I.t2f(this.q2f_1 + that.q2f_1 | 0, this.r2f_1 + that.r2f_1 | 0);
  }
  s2f(that) {
    return Vector2I.t2f(this.q2f_1 - that.q2f_1 | 0, this.r2f_1 - that.r2f_1 | 0);
  }
  toString() {
    return '(' + this.q2f_1 + ', ' + this.r2f_1 + ')';
  }
  hashCode() {
    var result = this.q2f_1;
    result = imul(result, 31) + this.r2f_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Vector2I))
      return false;
    var tmp0_other_with_cast = other instanceof Vector2I ? other : THROW_CCE();
    if (!(this.q2f_1 === tmp0_other_with_cast.q2f_1))
      return false;
    if (!(this.r2f_1 === tmp0_other_with_cast.r2f_1))
      return false;
    return true;
  }
}
//endregion
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
function _Angle___init__impl__g23q1m(radians) {
  return radians;
}
function _Angle___get_radians__impl__n00yt5($this) {
  return $this;
}
function _Angle___get_ratio__impl__ap3on4($this) {
  // Inline function 'korlibs.math.geom.Companion.radiansToRatio' call
  Companion_getInstance_0();
  var radians = _Angle___get_radians__impl__n00yt5($this);
  return _Ratio___init__impl__9mwvn2(radians / 6.283185307179586);
}
function _Angle___get_degrees__impl__qg56vw($this) {
  // Inline function 'korlibs.math.geom.Companion.radiansToDegrees' call
  Companion_getInstance_0();
  return _Angle___get_radians__impl__n00yt5($this) * 57.29577951308232;
}
function _Angle___get_cosine__impl__vprvmu($this) {
  // Inline function 'kotlin.math.cos' call
  var x = _Angle___get_radians__impl__n00yt5($this);
  return Math.cos(x);
}
function _Angle___get_sine__impl__15nmyi($this) {
  // Inline function 'kotlin.math.sin' call
  var x = _Angle___get_radians__impl__n00yt5($this);
  return Math.sin(x);
}
function _Angle___get_tangent__impl__vushdy($this) {
  // Inline function 'kotlin.math.tan' call
  var x = _Angle___get_radians__impl__n00yt5($this);
  return Math.tan(x);
}
function Angle__cosine_impl_bgvzun($this, up) {
  return _Angle___get_cosine__impl__vprvmu(adjustFromUp($this, up));
}
function Angle__sine_impl_3l11xv($this, up) {
  return _Angle___get_sine__impl__15nmyi(adjustFromUp($this, up));
}
function _Angle___get_absoluteValue__impl__4qoakv($this) {
  // Inline function 'kotlin.math.absoluteValue' call
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var this_0 = _Angle___get_radians__impl__n00yt5($this);
  var tmp$ret$1 = Math.abs(this_0);
  return _Angle___init__impl__g23q1m(tmp$ret$1);
}
function Angle__times_impl_v3s9y2($this, scale) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$0 = _Angle___get_radians__impl__n00yt5($this);
  return _Angle___init__impl__g23q1m(tmp$ret$0 * scale);
}
function Angle__div_impl_ut2btd($this, scale) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$0 = _Angle___get_radians__impl__n00yt5($this);
  return _Angle___init__impl__g23q1m(tmp$ret$0 / scale);
}
function Angle__times_impl_v3s9y2_0($this, scale) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$0 = _Angle___get_radians__impl__n00yt5($this);
  return _Angle___init__impl__g23q1m(tmp$ret$0 * scale);
}
function Angle__umod_impl_4wilf7($this, angle) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp = _Angle___get_radians__impl__n00yt5($this);
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$1 = _Angle___get_radians__impl__n00yt5(angle);
  return _Angle___init__impl__g23q1m(umod(tmp, tmp$ret$1));
}
function Angle__div_impl_ut2btd_0($this, other) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp = _Angle___get_radians__impl__n00yt5($this);
  // Inline function 'korlibs.math.geom.Angle.internal' call
  return tmp / _Angle___get_radians__impl__n00yt5(other);
}
function Angle__plus_impl_26v37k($this, other) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp = _Angle___get_radians__impl__n00yt5($this);
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$1 = _Angle___get_radians__impl__n00yt5(other);
  return _Angle___init__impl__g23q1m(tmp + tmp$ret$1);
}
function Angle__minus_impl_xeau7k($this, other) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp = _Angle___get_radians__impl__n00yt5($this);
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$1 = _Angle___get_radians__impl__n00yt5(other);
  return _Angle___init__impl__g23q1m(tmp - tmp$ret$1);
}
function Angle__unaryMinus_impl_7901fr($this) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$0 = _Angle___get_radians__impl__n00yt5($this);
  return _Angle___init__impl__g23q1m(-tmp$ret$0);
}
function Angle__unaryPlus_impl_eyi5pl($this) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$0 = _Angle___get_radians__impl__n00yt5($this);
  return _Angle___init__impl__g23q1m(+tmp$ret$0);
}
function Angle__isAlmostEquals_impl_201sgt($this, other, epsilon) {
  return isAlmostEquals(_Angle___get_radians__impl__n00yt5($this), _Angle___get_radians__impl__n00yt5(other), epsilon);
}
function Angle__isAlmostEquals_impl_201sgt_0($this, other, epsilon) {
  return Angle__isAlmostEquals_impl_201sgt($this.b25_1, other instanceof Angle ? other.b25_1 : THROW_CCE(), epsilon);
}
function _Angle___get_normalized__impl__9s30ys($this) {
  // Inline function 'korlibs.math.geom.Companion.fromRatio' call
  Companion_getInstance_0();
  var ratio = umod(Ratio__toDouble_impl_o7epze(_Angle___get_ratio__impl__ap3on4($this)), 1.0);
  // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
  var ratio_0 = toRatio(ratio);
  var tmp$ret$0 = Ratio__times_impl_ucdh7y(ratio_0, 6.283185307179586);
  return _Angle___init__impl__g23q1m(tmp$ret$0);
}
function Angle__compareTo_impl_a0hfds($this, other) {
  return Ratio__compareTo_impl_z2ienc(_Angle___get_ratio__impl__ap3on4($this), _Angle___get_ratio__impl__ap3on4(other));
}
function Angle__compareTo_impl_a0hfds_0($this, other) {
  return Angle__compareTo_impl_a0hfds($this.b25_1, other instanceof Angle ? other.b25_1 : THROW_CCE());
}
function Angle__toString_impl_786qky($this) {
  return get_niceStr(roundDecimalPlaces(_Angle___get_degrees__impl__qg56vw($this), 2)) + '.degrees';
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new Companion_0();
  return Companion_instance_0;
}
function Angle__hashCode_impl_szcndt($this) {
  return getNumberHashCode($this);
}
function Angle__equals_impl_zcf5mt($this, other) {
  if (!(other instanceof Angle))
    return false;
  var tmp0_other_with_cast = other instanceof Angle ? other.b25_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function get_degrees(_this__u8e3s4) {
  // Inline function 'korlibs.math.geom.Companion.fromDegrees' call
  // Inline function 'korlibs.math.geom.Companion.degreesToRadians' call
  Companion_getInstance_0();
  var tmp$ret$0 = _this__u8e3s4 * 0.017453292519943295;
  return _Angle___init__impl__g23q1m(tmp$ret$0);
}
function get_radians(_this__u8e3s4) {
  // Inline function 'korlibs.math.geom.Companion.fromRadians' call
  Companion_getInstance_0();
  return _Angle___init__impl__g23q1m(_this__u8e3s4);
}
function interpolateAngleDenormalized(_this__u8e3s4, l, r) {
  return interpolateAngle(_this__u8e3s4, l, r, false);
}
function get_radians_0(_this__u8e3s4) {
  // Inline function 'korlibs.math.geom.Companion.fromRadians' call
  Companion_getInstance_0();
  return _Angle___init__impl__g23q1m(_this__u8e3s4);
}
function adjustFromUp(_this__u8e3s4, up) {
  Companion_instance_10.l25(up);
  return up.n25_1 > 0 ? _this__u8e3s4 : Angle__unaryMinus_impl_7901fr(_this__u8e3s4);
}
function Angle_between(x0, y0, x1, y1, up) {
  up = up === VOID ? Companion_getInstance_17().s25_1 : up;
  // Inline function 'korlibs.math.geom.Companion.atan2' call
  Companion_getInstance_0();
  var x = y1 - y0;
  var y = x1 - x0;
  var up_0 = Companion_getInstance_17().s25_1;
  // Inline function 'korlibs.math.geom.Companion.fromRadians' call
  // Inline function 'kotlin.math.atan2' call
  var radians = Math.atan2(x, y);
  var tmp$ret$1 = _Angle___init__impl__g23q1m(radians);
  var angle = adjustFromUp(tmp$ret$1, up_0);
  return adjustFromUp(Angle__compareTo_impl_a0hfds(angle, Companion_getInstance_0().d25_1) < 0 ? Angle__plus_impl_26v37k(angle, Companion_getInstance_0().h25_1) : angle, up);
}
function interpolateAngle(_this__u8e3s4, l, r, minimizeAngle) {
  return _interpolateAngleAny(_this__u8e3s4, l, r, minimizeAngle);
}
function _interpolateAngleAny(ratio, l, r, minimizeAngle) {
  minimizeAngle = minimizeAngle === VOID ? true : minimizeAngle;
  if (!minimizeAngle) {
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    Companion_getInstance_0();
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    var ratio_0 = interpolate(ratio, _Angle___get_ratio__impl__ap3on4(l), _Angle___get_ratio__impl__ap3on4(r));
    var tmp$ret$0 = Ratio__times_impl_ucdh7y(ratio_0, 6.283185307179586);
    return _Angle___init__impl__g23q1m(tmp$ret$0);
  }
  var ln = _Angle___get_normalized__impl__9s30ys(l);
  var rn = _Angle___get_normalized__impl__9s30ys(r);
  var tmp;
  if (Angle__compareTo_impl_a0hfds(_Angle___get_absoluteValue__impl__4qoakv(Angle__minus_impl_xeau7k(rn, ln)), Companion_getInstance_0().f25_1) <= 0) {
    // Inline function 'korlibs.math.geom.Companion.fromRadians' call
    Companion_getInstance_0();
    var radians = interpolate_0(ratio, _Angle___get_radians__impl__n00yt5(ln), _Angle___get_radians__impl__n00yt5(rn));
    tmp = _Angle___init__impl__g23q1m(radians);
  } else if (Angle__compareTo_impl_a0hfds(ln, rn) < 0) {
    // Inline function 'korlibs.math.geom.Companion.fromRadians' call
    Companion_getInstance_0();
    var radians_0 = interpolate_0(ratio, _Angle___get_radians__impl__n00yt5(Angle__plus_impl_26v37k(ln, Companion_getInstance_0().h25_1)), _Angle___get_radians__impl__n00yt5(rn));
    var tmp$ret$3 = _Angle___init__impl__g23q1m(radians_0);
    tmp = _Angle___get_normalized__impl__9s30ys(tmp$ret$3);
  } else {
    // Inline function 'korlibs.math.geom.Companion.fromRadians' call
    Companion_getInstance_0();
    var radians_1 = interpolate_0(ratio, _Angle___get_radians__impl__n00yt5(ln), _Angle___get_radians__impl__n00yt5(Angle__plus_impl_26v37k(rn, Companion_getInstance_0().h25_1)));
    var tmp$ret$4 = _Angle___init__impl__g23q1m(radians_1);
    tmp = _Angle___get_normalized__impl__9s30ys(tmp$ret$4);
  }
  return tmp;
}
function _BoundsBuilder___init__impl__g6dprh(bounds) {
  return bounds;
}
function _BoundsBuilder___get_bounds__impl__s1l1gx($this) {
  return $this;
}
function _BoundsBuilder___get_isEmpty__impl__e9t785($this) {
  return _BoundsBuilder___get_bounds__impl__s1l1gx($this).b26();
}
function _BoundsBuilder___get_isNotEmpty__impl__w6rbsy($this) {
  return _BoundsBuilder___get_bounds__impl__s1l1gx($this).c26();
}
function _BoundsBuilder___get_xmin__impl__o2sib0($this) {
  // Inline function 'kotlin.math.min' call
  var a = _BoundsBuilder___get_bounds__impl__s1l1gx($this).d26();
  var b = _BoundsBuilder___get_bounds__impl__s1l1gx($this).e26();
  return Math.min(a, b);
}
function _BoundsBuilder___get_xmax__impl__gsz0km($this) {
  // Inline function 'kotlin.math.max' call
  var a = _BoundsBuilder___get_bounds__impl__s1l1gx($this).d26();
  var b = _BoundsBuilder___get_bounds__impl__s1l1gx($this).e26();
  return Math.max(a, b);
}
function _BoundsBuilder___get_ymin__impl__5n2e8j($this) {
  // Inline function 'kotlin.math.min' call
  var a = _BoundsBuilder___get_bounds__impl__s1l1gx($this).f26();
  var b = _BoundsBuilder___get_bounds__impl__s1l1gx($this).g26();
  return Math.min(a, b);
}
function _BoundsBuilder___get_ymax__impl__oia4uz($this) {
  // Inline function 'kotlin.math.max' call
  var a = _BoundsBuilder___get_bounds__impl__s1l1gx($this).f26();
  var b = _BoundsBuilder___get_bounds__impl__s1l1gx($this).g26();
  return Math.max(a, b);
}
function BoundsBuilder__xminOr_impl_k3l1m2($this, default_0) {
  return _BoundsBuilder___get_hasPoints__impl__6mwi9x($this) ? _BoundsBuilder___get_xmin__impl__o2sib0($this) : default_0;
}
function _BoundsBuilder___get_hasPoints__impl__6mwi9x($this) {
  return _BoundsBuilder___get_isNotEmpty__impl__w6rbsy($this);
}
var Companion_instance_1;
function Companion_getInstance_1() {
  if (Companion_instance_1 === VOID)
    new Companion_1();
  return Companion_instance_1;
}
function BoundsBuilder__plus_impl_cz7f7x($this, p) {
  if (_BoundsBuilder___get_bounds__impl__s1l1gx($this).b26())
    return _BoundsBuilder___init__impl__g6dprh(Companion_getInstance_12().u26(p, Size2D.t26(0, 0)));
  return _BoundsBuilder___init__impl__g6dprh(Companion_getInstance_12().q26(Companion_getInstance_17().w26(_BoundsBuilder___get_bounds__impl__s1l1gx($this).v26(), p), Companion_getInstance_17().y26(_BoundsBuilder___get_bounds__impl__s1l1gx($this).x26(), p)));
}
function BoundsBuilder__plus_impl_cz7f7x_0($this, rect) {
  if (rect == null)
    return $this;
  if (rect.b26())
    return $this;
  return BoundsBuilder__plus_impl_cz7f7x(BoundsBuilder__plus_impl_cz7f7x($this, rect.v26()), rect.x26());
}
function BoundsBuilder__plus_impl_cz7f7x_1($this, p) {
  var bb = $this;
  var inductionVariable = 0;
  var last = p.e1();
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      bb = BoundsBuilder__plus_impl_cz7f7x(bb, p.d1(n));
    }
     while (inductionVariable < last);
  return bb;
}
function BoundsBuilder__plus_impl_cz7f7x_2($this, rects) {
  var bb = $this;
  var _iterator__ex2g4s = rects.a1();
  while (_iterator__ex2g4s.b1()) {
    var it = _iterator__ex2g4s.c1();
    bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, it);
  }
  return bb;
}
function BoundsBuilder__boundsOrNull_impl_se9lyg($this) {
  return _BoundsBuilder___get_isEmpty__impl__e9t785($this) ? null : _BoundsBuilder___get_bounds__impl__s1l1gx($this);
}
function BoundsBuilder__toString_impl_fmvxh7($this) {
  return 'BoundsBuilder(bounds=' + $this.toString() + ')';
}
function BoundsBuilder__hashCode_impl_649zbo($this) {
  return $this.hashCode();
}
function BoundsBuilder__equals_impl_jngfjs($this, other) {
  if (!(other instanceof BoundsBuilder))
    return false;
  var tmp0_other_with_cast = other instanceof BoundsBuilder ? other.z26_1 : THROW_CCE();
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  return Companion_instance_2;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  return Companion_instance_3;
}
var Companion_instance_4;
function Companion_getInstance_4() {
  if (Companion_instance_4 === VOID)
    new Companion_4();
  return Companion_instance_4;
}
var Companion_instance_5;
function Companion_getInstance_5() {
  if (Companion_instance_5 === VOID)
    new Companion_5();
  return Companion_instance_5;
}
var Companion_instance_6;
function Companion_getInstance_6() {
  if (Companion_instance_6 === VOID)
    new Companion_6();
  return Companion_instance_6;
}
var Companion_instance_7;
function Companion_getInstance_7() {
  if (Companion_instance_7 === VOID)
    new Companion_7();
  return Companion_instance_7;
}
var MatrixType_IDENTITY_instance;
var MatrixType_TRANSLATE_instance;
var MatrixType_SCALE_instance;
var MatrixType_SCALE_TRANSLATE_instance;
var MatrixType_COMPLEX_instance;
var MatrixType_entriesInitialized;
function MatrixType_initEntries() {
  if (MatrixType_entriesInitialized)
    return Unit_instance;
  MatrixType_entriesInitialized = true;
  MatrixType_IDENTITY_instance = new MatrixType('IDENTITY', 0, 1, false, false, false);
  MatrixType_TRANSLATE_instance = new MatrixType('TRANSLATE', 1, 2, false, false, true);
  MatrixType_SCALE_instance = new MatrixType('SCALE', 2, 3, false, true, false);
  MatrixType_SCALE_TRANSLATE_instance = new MatrixType('SCALE_TRANSLATE', 3, 4, false, true, true);
  MatrixType_COMPLEX_instance = new MatrixType('COMPLEX', 4, 5, true, true, true);
}
var Companion_instance_8;
function Companion_getInstance_8() {
  if (Companion_instance_8 === VOID)
    new Companion_8();
  return Companion_instance_8;
}
function MatrixType_IDENTITY_getInstance() {
  MatrixType_initEntries();
  return MatrixType_IDENTITY_instance;
}
function MatrixType_TRANSLATE_getInstance() {
  MatrixType_initEntries();
  return MatrixType_TRANSLATE_instance;
}
function MatrixType_SCALE_getInstance() {
  MatrixType_initEntries();
  return MatrixType_SCALE_instance;
}
function MatrixType_SCALE_TRANSLATE_getInstance() {
  MatrixType_initEntries();
  return MatrixType_SCALE_TRANSLATE_instance;
}
function MatrixType_COMPLEX_getInstance() {
  MatrixType_initEntries();
  return MatrixType_COMPLEX_instance;
}
var Companion_instance_9;
function Companion_getInstance_9() {
  if (Companion_instance_9 === VOID)
    new Companion_9();
  return Companion_instance_9;
}
function ortho(_this__u8e3s4, rect, near, far) {
  near = near === VOID ? 0.0 : near;
  far = far === VOID ? 1.0 : far;
  return Companion_getInstance_9().k2d(rect.d26(), rect.e26(), rect.g26(), rect.f26(), near, far);
}
function scaled(_this__u8e3s4, scale) {
  return _this__u8e3s4.g2a(scale.o2d_1, scale.p2d_1);
}
function get_scale(_this__u8e3s4) {
  return Scale.q2d(_this__u8e3s4.i2b_1, _this__u8e3s4.j2b_1);
}
var Orientation_CLOCK_WISE_instance;
var Orientation_COUNTER_CLOCK_WISE_instance;
var Orientation_COLLINEAR_instance;
var Companion_instance_10;
function Companion_getInstance_10() {
  return Companion_instance_10;
}
var Orientation_entriesInitialized;
function Orientation_initEntries() {
  if (Orientation_entriesInitialized)
    return Unit_instance;
  Orientation_entriesInitialized = true;
  Orientation_CLOCK_WISE_instance = new Orientation('CLOCK_WISE', 0, 1);
  Orientation_COUNTER_CLOCK_WISE_instance = new Orientation('COUNTER_CLOCK_WISE', 1, -1);
  Orientation_COLLINEAR_instance = new Orientation('COLLINEAR', 2, 0);
}
var Companion_instance_11;
function Companion_getInstance_11() {
  if (Companion_instance_11 === VOID)
    new Companion_11();
  return Companion_instance_11;
}
var Companion_instance_12;
function Companion_getInstance_12() {
  if (Companion_instance_12 === VOID)
    new Companion_12();
  return Companion_instance_12;
}
function outerCircle(_this__u8e3s4) {
  var centerX = _this__u8e3s4.v2e();
  var centerY = _this__u8e3s4.w2e();
  return new Circle(_this__u8e3s4.x2e(), Companion_getInstance_17().n2f(centerX, centerY, _this__u8e3s4.e26(), _this__u8e3s4.f26()));
}
var Companion_instance_13;
function Companion_getInstance_13() {
  return Companion_instance_13;
}
var Companion_instance_14;
function Companion_getInstance_14() {
  if (Companion_instance_14 === VOID)
    new Companion_14();
  return Companion_instance_14;
}
function toVector2(_this__u8e3s4) {
  return Vector2D.w27(_this__u8e3s4.o2d_1, _this__u8e3s4.p2d_1);
}
function ScaleMode$Companion$COVER$lambda(i, c) {
  return i.d2e(toVector2(c.e2g(i)).f2g());
}
function ScaleMode$Companion$SHOW_ALL$lambda(i, c) {
  return i.d2e(toVector2(c.e2g(i)).g2g());
}
function ScaleMode$Companion$EXACT$lambda(i, c) {
  return c;
}
function ScaleMode$Companion$NO_SCALE$lambda(i, c) {
  return i;
}
var Companion_instance_15;
function Companion_getInstance_15() {
  if (Companion_instance_15 === VOID)
    new Companion_15();
  return Companion_instance_15;
}
var Companion_instance_16;
function Companion_getInstance_16() {
  if (Companion_instance_16 === VOID)
    new Companion_16();
  return Companion_instance_16;
}
function toFloat(_this__u8e3s4) {
  return Size2D.g2e(_this__u8e3s4.v2g_1, _this__u8e3s4.w2g_1);
}
function toInt(_this__u8e3s4) {
  return SizeInt.x2g(numberToInt(_this__u8e3s4.r26_1), numberToInt(_this__u8e3s4.s26_1));
}
function times(_this__u8e3s4, other) {
  return Vector2D.w27(_this__u8e3s4.m25_1 * other.r26_1, _this__u8e3s4.n25_1 * other.s26_1);
}
function toSize(_this__u8e3s4) {
  return Size2D.l2e(_this__u8e3s4.m25_1, _this__u8e3s4.n25_1);
}
function transformX(_this__u8e3s4, m) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    if (m.b26()) {
      tmp$ret$0 = _this__u8e3s4;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.w27(m.y29(_this__u8e3s4.m25_1, _this__u8e3s4.n25_1), m.b2a(_this__u8e3s4.m25_1, _this__u8e3s4.n25_1));
  }
  return tmp$ret$0.m25_1;
}
function transformY(_this__u8e3s4, m) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    if (m.b26()) {
      tmp$ret$0 = _this__u8e3s4;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.w27(m.y29(_this__u8e3s4.m25_1, _this__u8e3s4.n25_1), m.b2a(_this__u8e3s4.m25_1, _this__u8e3s4.n25_1));
  }
  return tmp$ret$0.n25_1;
}
function square($this, x) {
  return x * x;
}
var Companion_instance_17;
function Companion_getInstance_17() {
  if (Companion_instance_17 === VOID)
    new Companion_17();
  return Companion_instance_17;
}
function toInt_0(_this__u8e3s4) {
  return Vector2I.t2f(numberToInt(_this__u8e3s4.m25_1), numberToInt(_this__u8e3s4.n25_1));
}
var Companion_instance_18;
function Companion_getInstance_18() {
  if (Companion_instance_18 === VOID)
    new Companion_18();
  return Companion_instance_18;
}
var Companion_instance_19;
function Companion_getInstance_19() {
  if (Companion_instance_19 === VOID)
    new Companion_19();
  return Companion_instance_19;
}
var Companion_instance_20;
function Companion_getInstance_20() {
  if (Companion_instance_20 === VOID)
    new Companion_20();
  return Companion_instance_20;
}
function times_0(_this__u8e3s4, v) {
  // Inline function 'korlibs.math.geom.Vector2F.times' call
  // Inline function 'korlibs.math.geom.Vector2F.times' call
  return Vector2F.p2i(v.q2e_1 * _this__u8e3s4, v.r2e_1 * _this__u8e3s4);
}
var Companion_instance_21;
function Companion_getInstance_21() {
  if (Companion_instance_21 === VOID)
    new Companion_21();
  return Companion_instance_21;
}
function interpolate_1(_this__u8e3s4, l, r) {
  return Vector2D.w27(interpolate_0(_this__u8e3s4, l.m25_1, r.m25_1), interpolate_0(_this__u8e3s4, l.n25_1, r.n25_1));
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForClass(Anchor2D, 'Anchor2D');
initMetadataForCompanion(Companion_0);
protoOf(Angle).fx = isAlmostEquals$default;
initMetadataForClass(Angle, 'Angle', VOID, VOID, [Comparable, IsAlmostEquals]);
initMetadataForCompanion(Companion_1);
initMetadataForClass(BoundsBuilder, 'BoundsBuilder');
initMetadataForCompanion(Companion_2);
initMetadataForClass(Circle, 'Circle');
initMetadataForClass(IPointList$Sublist$listIterator$1);
initMetadataForClass(Sublist, 'Sublist', VOID, VOID, [KtList]);
initMetadataForCompanion(Companion_3);
initMetadataForInterface(IDoubleVectorList, 'IDoubleVectorList', VOID, VOID, [IsAlmostEquals]);
initMetadataForInterface(IPointList, 'IPointList', VOID, VOID, [IDoubleVectorList, KtList]);
initMetadataForCompanion(Companion_4);
initMetadataForClass(Line2D, 'Line2D', Line2D.g28);
initMetadataForCompanion(Companion_5);
protoOf(Margin).fx = isAlmostEquals$default;
initMetadataForClass(Margin, 'Margin', VOID, VOID, [IsAlmostEquals]);
initMetadataForCompanion(Companion_6);
initMetadataForClass(MarginInt, 'MarginInt');
initMetadataForCompanion(Companion_7);
protoOf(Matrix).fx = isAlmostEquals$default;
initMetadataForClass(Matrix, 'Matrix', VOID, VOID, [IsAlmostEquals]);
initMetadataForClass(MatrixType, 'MatrixType');
initMetadataForCompanion(Companion_8);
protoOf(MatrixTransform).fx = isAlmostEquals$default;
initMetadataForClass(MatrixTransform, 'MatrixTransform', VOID, VOID, [IsAlmostEquals]);
initMetadataForCompanion(Companion_9);
initMetadataForClass(Matrix4, 'Matrix4', Matrix4.p2c);
initMetadataForCompanion(Companion_10);
initMetadataForClass(Orientation, 'Orientation');
initMetadataForCompanion(Companion_11);
initMetadataForClass(RectCorners, 'RectCorners');
initMetadataForCompanion(Companion_12);
protoOf(Rectangle).fx = isAlmostEquals$default;
initMetadataForClass(Rectangle, 'Rectangle', VOID, VOID, [IsAlmostEquals]);
initMetadataForCompanion(Companion_13);
initMetadataForClass(RectangleInt, 'RectangleInt', RectangleInt.u2f);
initMetadataForCompanion(Companion_14);
initMetadataForClass(Scale, 'Scale', Scale.a2g);
initMetadataForCompanion(Companion_15);
initMetadataForClass(ScaleMode, 'ScaleMode');
initMetadataForCompanion(Companion_16);
initMetadataForClass(Size2D, 'Size2D', Size2D.q2g);
initMetadataForClass(SizeInt, 'SizeInt', SizeInt.y2g);
initMetadataForCompanion(Companion_17);
protoOf(Vector2D).fx = isAlmostEquals$default;
initMetadataForClass(Vector2D, 'Vector2D', Vector2D.h28, VOID, [IsAlmostEquals]);
initMetadataForCompanion(Companion_18);
initMetadataForClass(Vector4F, 'Vector4F');
initMetadataForCompanion(Companion_19);
initMetadataForClass(Vector3F, 'Vector3F');
initMetadataForCompanion(Companion_20);
initMetadataForClass(Vector2F, 'Vector2F', Vector2F.s2i);
initMetadataForCompanion(Companion_21);
initMetadataForClass(Vector2I, 'Vector2I', Vector2I.u2i);
//endregion
//region block: init
Companion_instance_2 = new Companion_2();
Companion_instance_3 = new Companion_3();
Companion_instance_10 = new Companion_10();
Companion_instance_13 = new Companion_13();
//endregion
//region block: exports
export {
  MatrixType_IDENTITY_getInstance as MatrixType_IDENTITY_getInstance26n3n49ggvwm4,
  _Angle___init__impl__g23q1m as _Angle___init__impl__g23q1m36yxttgnpy5tv,
  _Angle___get_absoluteValue__impl__4qoakv as _Angle___get_absoluteValue__impl__4qoakv4cdwg294ssle,
  Angle__compareTo_impl_a0hfds as Angle__compareTo_impl_a0hfds24obl4qqhxk1t,
  _Angle___get_cosine__impl__vprvmu as _Angle___get_cosine__impl__vprvmu3ab5uwcliuboq,
  Angle__cosine_impl_bgvzun as Angle__cosine_impl_bgvzun1b2925dagclby,
  _Angle___get_degrees__impl__qg56vw as _Angle___get_degrees__impl__qg56vw2n539uvc01e1n,
  Angle__div_impl_ut2btd as Angle__div_impl_ut2btd1qmy7ftoy1opp,
  Angle__div_impl_ut2btd_0 as Angle__div_impl_ut2btd19ndx9mxcgcss,
  Angle__hashCode_impl_szcndt as Angle__hashCode_impl_szcndtx0rhatnvuhb1,
  Angle__minus_impl_xeau7k as Angle__minus_impl_xeau7ko02ca30grn4a,
  _Angle___get_normalized__impl__9s30ys as _Angle___get_normalized__impl__9s30ys1q15xt9x23bx,
  Angle__plus_impl_26v37k as Angle__plus_impl_26v37karx983dsduoy,
  _Angle___get_radians__impl__n00yt5 as _Angle___get_radians__impl__n00yt518seywpfbf9fr,
  _Angle___get_ratio__impl__ap3on4 as _Angle___get_ratio__impl__ap3on435dv91f5cbp85,
  _Angle___get_sine__impl__15nmyi as _Angle___get_sine__impl__15nmyi39oh4tio4auz1,
  Angle__sine_impl_3l11xv as Angle__sine_impl_3l11xv3pgl8zzgp52i0,
  _Angle___get_tangent__impl__vushdy as _Angle___get_tangent__impl__vushdy2zy6w59e4l7qg,
  Angle__times_impl_v3s9y2_0 as Angle__times_impl_v3s9y21yznxo5bj1uj7,
  Angle__times_impl_v3s9y2 as Angle__times_impl_v3s9y220yjbrxc13c3b,
  Angle__toString_impl_786qky as Angle__toString_impl_786qkyjyicm41uc2nj,
  Angle__umod_impl_4wilf7 as Angle__umod_impl_4wilf71vq5gai237g1r,
  Angle__unaryMinus_impl_7901fr as Angle__unaryMinus_impl_7901fruk5m76f5kg06,
  Angle__unaryPlus_impl_eyi5pl as Angle__unaryPlus_impl_eyi5plrfyn5fslhvdp,
  _BoundsBuilder___get_bounds__impl__s1l1gx as _BoundsBuilder___get_bounds__impl__s1l1gx2fs31mzomv5i,
  BoundsBuilder__boundsOrNull_impl_se9lyg as BoundsBuilder__boundsOrNull_impl_se9lyg1z0iqowyff423,
  BoundsBuilder__hashCode_impl_649zbo as BoundsBuilder__hashCode_impl_649zbo2cbmgnd4y2see,
  BoundsBuilder__plus_impl_cz7f7x as BoundsBuilder__plus_impl_cz7f7xocbq7jeozma3,
  BoundsBuilder__plus_impl_cz7f7x_2 as BoundsBuilder__plus_impl_cz7f7xqnc8b6uzo82y,
  BoundsBuilder__plus_impl_cz7f7x_1 as BoundsBuilder__plus_impl_cz7f7xiu6sbkxslhhl,
  BoundsBuilder__plus_impl_cz7f7x_0 as BoundsBuilder__plus_impl_cz7f7xm06pofb9kabm,
  BoundsBuilder__toString_impl_fmvxh7 as BoundsBuilder__toString_impl_fmvxh7qh65bafrb2p,
  _BoundsBuilder___get_xmax__impl__gsz0km as _BoundsBuilder___get_xmax__impl__gsz0km31n4zf6la54qa,
  _BoundsBuilder___get_xmin__impl__o2sib0 as _BoundsBuilder___get_xmin__impl__o2sib0fqg01yornfcx,
  BoundsBuilder__xminOr_impl_k3l1m2 as BoundsBuilder__xminOr_impl_k3l1m233j5xey4uzzri,
  _BoundsBuilder___get_ymax__impl__oia4uz as _BoundsBuilder___get_ymax__impl__oia4uz2kb33iwdnvg1r,
  _BoundsBuilder___get_ymin__impl__5n2e8j as _BoundsBuilder___get_ymin__impl__5n2e8j1x2fwruhjr6r5,
  Companion_getInstance as Companion_getInstanceeqp3ibr2vvu9,
  Companion_getInstance_0 as Companion_getInstance3rze5babd97ff,
  Companion_getInstance_1 as Companion_getInstance2yu48324co92b,
  Companion_getInstance_5 as Companion_getInstance3la8ioxhl91va,
  Companion_getInstance_6 as Companion_getInstancenbeyvbsm21qs,
  Companion_getInstance_7 as Companion_getInstance1zxby1ngivg0d,
  Companion_getInstance_9 as Companion_getInstance3qti4zygy7usz,
  Companion_getInstance_11 as Companion_getInstance3lu3946d91kk8,
  Companion_getInstance_12 as Companion_getInstance1bdwtq6rroayu,
  Companion_instance_13 as Companion_instanceu31qrc8c1r0r,
  Companion_getInstance_15 as Companion_getInstance23o88a0u6ly94,
  Companion_getInstance_16 as Companion_getInstance1j5nd3fbu9uao,
  Companion_getInstance_17 as Companion_getInstancewdpvtc2ehxkt,
  Companion_getInstance_19 as Companion_getInstance1yq7a1f60lp2k,
  Anchor2D as Anchor2D3ucppq7m9n3z8,
  Angle_between as Angle_between72970e1vlen9,
  Angle as Angle2itorpob18n08,
  BoundsBuilder as BoundsBuilder162uwsje56mvu,
  isAlmostEquals_0 as isAlmostEquals2qd88bwpjj4z5,
  isNotEmpty as isNotEmptyrwyeygz7izwg,
  IDoubleVectorList as IDoubleVectorListoa05cse3he2p,
  containsAll as containsAll194lepx84fvib,
  indexOf as indexOf3tp8bzbv46hci,
  iterator as iterator1sm8hwbj0nmg8,
  listIterator as listIteratorrk3szyua4uzm,
  listIterator_0 as listIterator3ooh2yjav3kr9,
  subList as subList2funs4qwcrhhq,
  IPointList as IPointListz7raskb2mrxa,
  Line2D as Line2D2pf35pcx71ncp,
  MarginInt as MarginInt3jiec8xsxkfd,
  Margin as Marginzmgz0t8x8vn,
  Matrix4 as Matrix43neeu8v4zk4i7,
  MatrixTransform as MatrixTransform1wlsrhxt7473v,
  Matrix as Matrix1p940sdz227jj,
  RectCorners as RectCorners2yrtl8r42p5bs,
  RectangleInt as RectangleInt3lmu13ytuf5lk,
  Rectangle as Rectangle3q03woyn9k8x1,
  Scale as Scale2cm697xlulcp5,
  Size2D as Size2Dum5ayuyhhau7,
  SizeInt as SizeInte6w85oa6mz6v,
  Vector2D as Vector2D378fe5rov8fgw,
  Vector2F as Vector2F2yb91r49vy4m7,
  Vector2I as Vector2I2k5512l4eeahb,
  Vector4F as Vector4F1clr35ctch8js,
  adjustFromUp as adjustFromUp1ak85cceintt4,
  get_degrees as get_degrees3czcd4ojw4i,
  interpolateAngleDenormalized as interpolateAngleDenormalized1hkwzk523mo1c,
  ortho as orthow9c0o91bw54n,
  outerCircle as outerCircle30hn5vvbpz9gu,
  get_radians as get_radians391vbqqjsolq6,
  get_scale as get_scale17gmsnxnqj6j9,
  scaled as scaled2eehd42i2trq9,
  times_0 as times2qwyhtxg42qph,
  times as timesatqrmkwmiu2z,
  toFloat as toFloat3b315y36g90cd,
  toInt as toIntp2twe4onfbic,
  toInt_0 as toIntu0rc68akxu7a,
  transformX as transformX33nszy4vzqsfy,
  transformY as transformY3ktoxhxwkzwk1,
  interpolate_1 as interpolatewhd2sgxffql5,
};
//endregion
